{
    "headerData1": "MyHelp",
    "headerData2": "Asistentul tău AI pentru suport IT",
    "headerMessage": "Folosește <span class='me8eon'>MyHelp</span> pentru a remedia probleme IT, a urma ghiduri pas cu pas sau pentru a fi direcționat către canalul potrivit de suport IT.",
    "loginLable": "Logare",
    "logOff": "Delogare",
    "logIn": "Logare",
    "userName": "Nume utilizator",
    "switchLanguage": "Schimba limba",
    "switchRole": "Schimba rolul",
    "new": "NOU",
    "whatsnew": "Vezi ce este nou",
    "whatsnewtt": "Afla ce este nou in MyHelp",
    "organiseTiles": "Organizeaza spatiul de lucru",
    "confirm": "Confirma",
    "cancel": "Anuleaza",
    "close": "Inchide",
    "reset": "Reseteaza",
    "continue_Tour": "Continua turul",
    "skip_Tour": "Skip tour",
    "save": "Salveaza",
    "submit": "Trimite",
    "delete": "Sterge",
    "trash_bin": "Cos pentru fisierele sterse temporar",
    "edit": "Editeaza",
    "yes": "Da",
    "no": "Nu",
    "feedbackWidget": "Feedbackul tău",
    "itSupportPrompt": "Am nevoie de suport IT",
    "redirectingToITSupportAgent": "Redirecționare către agentul de asistență IT",
    "restoredWidgetNotice": "Dintr-o conversație anterioară. Acțiunile sunt dezactivate; întrebați din nou pentru a începe o solicitare nouă.",
    "myITsupport": "Suportul meu IT",
    "shareViaOutlook": "Partajează prin Outlook",
    "registerLable": "Catre inregistrare ",
    "underDevelopmentMsg": "Aceasta pagina este in constructie",
    "apiFailDefaultMsg": "Ceva nu a functionat. Te rugam sa incerci din nou mai tarziu",
    "more": "Mai mult",
    "searchResult": "Rezultatele cautarii",
    "showAll": "Arata toate",
    "showRelevant": "Arata ce e relevant",
    "assistantTabTooltip": "Asistentul AI răspunde întrebarilor tale căutand raspunsul în timp real în resursele interne de documente ale E.ON. Oferă răspunsuri clare, usor de înțeles, dar și documentele sursă, pentru ca tu să ai încredere în informația prezentată",
    "searchTabTooltip": "Căutare E.ON reprezintă o metoda clasică de căutare - te ajută să găsesti informația relevantă în diferite surse de documente E.ON, precum și în propriile tale documente. Oferă cele mai relevante rezultate, dar și link-urile catre documentele sursă",
    "landingPage": {
        "hello": "Buna",
        "title": "cu ce te pot ajuta?",
        "searchApps": "Aplicatii",
        "suggestions": "Sugestii"
    },
    "footer": {
        "imprint": "Imprint",
        "privacyPolicy": "Politica de confidentialitate",
        "termsofUse": "Termeni de utilizare",
        "contact": "Contact",
        "PKI": "PKI",
        "privacySettings": "Setari de confidentialitate",
        "aboutMe8EON": "Despre MyHelp",
        "copyrights": "Conținut protejat prin drepturi de autor"
    },
    "tilePage": {
        "backToSearch": "Inapoi la pagina anterioara",
        "myInboxCountSuffix": "In asteptare"
    },
    "myApprovalDataTable": {
        "FilterLable": {
            "all": "Toate",
            "leaveApptoval": "Aprobarea concediului",
            "timeSheet": "Fisa de pontaj",
            "claim": "Cerere - Revendicate",
            "serviceRequest": "Solicitare suport"
        },
        "tableData": {
            "approve": "Aproba",
            "reject": "Nu aproba",
            "requestId": "ID ul cererii",
            "description": "Descriere",
            "requestedBy": "Cerere initiata de",
            "requestedType": "Tipul cererii",
            "requestedDate": "Data cererii",
            "status": "Status"
        }
    },
    "appData": {
        "time": "Inregistrarea timpului de lucru",
        "meeting": "Rezervare sala de sedinte",
        "approval": "Aprobările mele",
        "pr": "Creare cerere de achiziție",
        "pra": "Creare cerere de achiziție avansată",
        "processing": "Inbox-ul meu",
        "hr": "HR Portal",
        "hrLabel": "HR Portal",
        "concur": "Concur Travel Rezervari si cheltuieli",
        "password": "SAP Resetarea parolei",
        "ariba": "Ariba - Clasic si Clasic+",
        "itresources": "Resurse IT",
        "myassets": "Activele mele",
        "order": "Comanda",
        "incident": "Incidente",
        "beeline": "Beeline",
        "prisma": "Prisma",
        "gertrud": "Gertrud",
        "notification": "Portal Notificari",
        "zuko": "Zuko",
        "eon_brand": "Spatiu brand EON ",
        "pki": "PKI Portal",
        "mail": "Mail DL",
        "journey": "Trasee/Evenimente",
        "mygenius": "MyGenius",
        "ideeon": "idEE.ON",
        "ideenet": "IdeeNet",
        "dpf": " Fisiere Personal - Fisiere Personal Digitale - DPF",
        "corpsac": "SAC Corporate ",
        "corpportal": "Portal Corporate",
        "redwood": "Redwood AutomatizariFinanciare",
        "eamsap200": "EAM (200)",
        "eamsap100": "EAM (100)",
        "sodsap": "SoD SAP Portal",
        "videon": "VidE.ON",
        "alteryx": "Alteryx",
        "ebam": "Banking: Bank Acc Mgmt (EBAM)",
        "egs": "E.ON Solutii Garantii",
        "epsnext": "EPSnext",
        "fisquantum": "FIS Quantum",
        "rms": "RMS - Managementul Riscului",
        "slido": "Slido",
        "insightslibrary": "Colectii de informatii utile",
        "getabstract": "creeaza Abstract",
        "mypotential": "Indeplinirea propriului Potential",
        "dsesoftware": "DSE Software",
        "whistleblowing": "E.ON Sistem de avertizare interna",
        "maqsima": "MAQSIMA TMS",
        "digitalrulebook": "Paula Policy",
        "oneERP": "OneERP",
        "Perseus": "Vorfallsmeldung",
        "cateringportal": "Speiseplan",
        "westnetzregelwerke": "Regelwerke Westnetz",
        "werbemittel": "Werbemittel",
        "westenergie_brand": "Brand-Management-Portal",
        "compass": "Compass",
        "gradar": "Gradar",
        "beqom": "beqom",
        "kyc": "KYC",
        "talentry": "Talentry",
        "sam": "SAM",
        "enorm": "e-NORM",
        "redonline": "ROL",
        "tagetikcpm": "Tagetik CPM",
        "tagetikcpmerm": "Tagetik CPM and ERM",
        "smartguide": "Smart Guide",
        "tagetiksac": "Tagetik SAC",
        "myit": "my IT",
        "timehover": "Cu aplicația CATS, poți urmări și gestiona cu ușurință orele de lucru și activitățile, având toate informațiile și funcțiile relevante într-un singur loc",
        "meetinghover": "Cu Gingco, instrumentul nostru de rezervare a sălilor, poți gestiona și programa cu ușurință sălile de ședință și resursele, asigurând o utilizare eficientă și disponibilitate, totul într-un singur loc.",
        "approvalhover": "Cu myInbox, poți aproba facturile rapid și eficient, având toate informațiile și acțiunile relevante într-un singur loc",
        "prhover": "Aici poți găsi toate funcțiile relevante pentru a solicita bunuri și servicii. Este cunoscut și sub denumirea de BANF (prescurtare germană pentru cerere de achiziție)",
        "prahover": "Aici poți găsi toate funcțiile relevante pentru a solicita bunuri și servicii. Este cunoscut și sub denumirea de BANF (prescurtare germană pentru cerere de achiziție)",
        "processinghover": "Cu myInbox, poți aproba facturile rapid și eficient, având toate informațiile și acțiunile relevante într-un singur loc",
        "hrhover": "Cu myHR, poți accesa și gestiona cu ușurință informațiile și sarcinile legate de resursele umane într-un singur loc",
        "concurhover": "Cu Concur, poți gestiona și trimite cu ușurință rapoartele de călătorie și cheltuieli, având toate informațiile și acțiunile relevante într-un singur loc",
        "passwordhover": "Cu această placă, poți reseta cu ușurință parolele de acces pentru sistemele SAP.",
        "aribahover": "Cu SAP Ariba, poți gestiona cu ușurință procesele de achiziție, având toate informațiile și instrumentele relevante într-un singur loc",
        "itresourceshover": "IT Resources",
        "myassetshover": "My Assets",
        "orderhover": "Order",
        "incidenthover": "Incidents",
        "beelinehover": "Cu Beeline, poți gestiona eficient forța de muncă temporară și poți optimiza procesele de recrutare accesând toate instrumentele și informațiile necesare într-un singur loc.",
        "prismahover": "PRISMA este prescurtarea de la Platform for Reporting on Incident and Sustainability Management and Auditing (Platforma pentru Raportarea Incidentelor și Managementul Sustenabilității și Audit). Platforma sprijină departamentul HSE al E.ON în misiunea sa de a face din E.ON un loc ce prioritizează sănătatea organizațională, siguranța și responsabilitatea cu privire la mediu. Puteți downloada aplicația PRISMA, dar o puteți accesa și pe internet, prin intermediul site-ului web",
        "gertrudhover": "Gertrud",
        "notificationhover": "Portal Notificari",
        "zukohover": "Zuko",
        "eon_brandhover": "Spatiu Brand EON",
        "pkihover": "PKI Portal",
        "mailhover": "Mail DL",
        "journeyhover": "Trasee/Evenimente",
        "mygeniushover": "MyGenius",
        "ideeonhover": "Idee.on este o platformă care permite angajaților să trimită și să evalueze idei și sugestii pentru managementul ideilor. Este concepută pentru a facilita un proces de îmbunătățire continuă în toate domeniile companiei.",
        "ideenethover": "IdeeNet este un software de management al ideilor în adevăratul sens al cuvântului. O varietate largă de idei, precum &#10;&bull; BVW centralizat, BVW descentralizat și forme mixte &#10;&bull; Cercuri de calitate și CIP &#10;&bull; Rapoarte de erori și reclamații &#10;&bull; Invenții ale angajaților &#10;pot fi gestionate eficient cu acest software, într-o bază de date unificată de idei, folosind diverse strategii.",
        "dpfhover": "Fișierul tău personal conține mult mai multe documente decât cele afișate permanent în MyHR! &#10;Trimite o solicitare HR și cere acces la întregul fișier personal! După o verificare profesională, acesta va fi pus la dispoziție prin link direct.",
        "corpsachover": "SAC este un instrument puternic de vizualizare cu capabilități avansate de planificare.",
        "corpportalhover": "Portalul Corporate este o platformă internă centrală de aplicații cu integrare și dezvoltare de aplicații bazate pe roluri pentru acces Single-Sign-On la backend-urile SAP.",
        "redwoodhover": "Redwood FA este folosit pentru programarea consolidării situațiilor financiare și automatizarea activităților individuale.",
        "eamsap200hover": "Enterprise Asset Management &#10;Mediu pentru dezvoltări proprii bazate pe Business technology platform (BTP) de la SAP (fostul SAP Cloud Platform) - cont EAM pentru cockpit-uri de rețea, inclusiv instanțele cloud: producție, QA (Quality Assurance), dezvoltare și staging.",
        "eamsap100hover": "Enterprise Asset Management &#10;Mediu pentru dezvoltări proprii bazate pe Business technology platform (BTP) de la SAP (fostul SAP Cloud Platform) - cont EAM pentru cockpit-uri de rețea, inclusiv instanțele cloud: producție, QA (Quality Assurance), dezvoltare și staging.",
        "sodsaphover": "Portalul SOD este conceput pentru a simplifica și digitaliza gestionarea Segregation of Duties (SOD). Prin digitalizarea identificării, monitorizării și rezolvării conflictelor SOD, asigură conformitatea cu standardele de reglementare și îmbunătățește securitatea organizațională. Acest instrument este esențial pentru menținerea unui sistem robust de control intern și protejarea operațiunilor de afaceri.",
        "videonhover": "Aplicație pentru rezervarea serviciilor de studio video/TV la Brüsseler Platz pentru producții video/TV sau evenimente de streaming.",
        "alteryxhover": "Platformă de analiză de date utilizată pentru crearea de aplicații analitice și fluxuri de lucru. Permite utilizatorilor să gestioneze și să partajeze aplicații analitice, să ruleze fluxuri de lucru și să acceseze și să raporteze rezultatele într-un mediu de server.",
        "ebamhover": "Management electronic al conturilor bancare.",
        "egshover": "E.ON SE preia garanții și asigurări pentru BU-urile grupului către creditori externi.",
        "epsnexthover": "Instrument electronic central de banking pentru toate MU/Bus.",
        "fisquantumhover": "Soluția FIS Quantum Treasury Management este concepută pentru a îmbunătăți eficiența și eficacitatea operațiunilor de trezorerie ale organizației. Această platformă cloud-native oferă vizibilitate în timp real asupra lichidității, facilitând luarea deciziilor privind capitalul și gestionarea riscurilor. Cu funcții avansate pentru gestionarea datoriilor, investițiilor și conformității, ajută la optimizarea fluxurilor de lucru și la îmbunătățirea performanței financiare.",
        "rmshover": "Sistem de management al riscului la nivel de grup E.ON (procesarea cererilor de credit și sistem de management al riscului de credit).",
        "slidohover": "Slido este o platformă interactivă concepută pentru a spori implicarea audienței și pentru a colecta informații în timpul evenimentelor live sau virtuale, întâlnirilor și prezentărilor. Permite utilizatorilor să realizeze sondaje live, sesiuni de întrebări și răspunsuri și quiz-uri în timp real, creând o experiență dinamică și participativă pentru audiență.",
        "insightslibraryhover": "Insights Library este depozitul central de cunoștințe al E.ON pentru informații despre clienți și piață în cadrul businessului de soluții pentru clienți.",
        "getabstracthover": "getAbstract este biblioteca online la nivel de grup E.ON, oferită de getAbstract, cu rezumate de cărți, articole și alte formate de învățare care acoperă toate competențele relevante pentru afaceri (competențe soft și funcționale).",
        "mypotentialhover": "Sistem pentru angajații și managerii din UK pentru a înregistra performanța, obiectivele și evaluările.",
        "dsesoftwarehover": "Instruire și evaluări privind utilizarea ecranelor pentru sănătate și securitate.",
        "whistleblowinghover": "Instrumentul de Whistleblowing permite oricui să transmită informații și să depună o sesizare anonim. Acest lucru se poate face prin web, email sau telefon. În timpul apelului, vocea va fi distorsionată.",
        "maqsimahover": "Managementul evaluărilor de risc, instrucțiunilor de operare, substanțelor periculoase &#10;Maqsima te ajută să urmărești rapid și ușor toate evaluările de risc și instrucțiunile de operare relevante și să le menții actualizate într-un mod inteligent.",
        "digitalrulebookhover": "Paula Policy este asistentul bazat pe inteligență artificială pentru politicile corporative E.ON, oferind angajaților acces rapid și ușor la People Guidelines, Function Policies și Codul de Conduită. Furnizează răspunsuri consecvente și fiabile, făcând politicile complexe ușor de înțeles și accesibile.",
        "oneERPhover": "Portalul one.ERP este o platformă centrală în cadrul grupului Westenergie care consolidează diverse funcții și informații legate de ERP. Servește ca un hub de informații și control pentru utilizatorii ERP și managerii IT și face parte din strategia de digitalizare a grupului.",
        "Perseushover": "Portalul de Securitate este punctul central de acces pentru raportarea incidentelor legate de securitate în cadrul organizațiilor Westenergie și Westnetz. Este utilizat frecvent împreună cu sistemul intern de raportare Perseus, care este conceput special pentru gestionarea incidentelor precum pierderea dispozitivelor, furtul sau încălcările protecției datelor.",
        "cateringportalhover": "Portalul eon.cateringportal.io este platforma digitală pentru aplicația E.ON Canteen. Oferă meniuri, detalii despre locații și alte servicii de catering pentru angajații E.ON.",
        "westnetzregelwerkehover": "Acest portal servește ca resursă centrală pentru reglementări tehnice și documentație legate de operarea și gestionarea rețelelor de electricitate și gaze. Asigură accesul la toate ghidurile, standardele și specificațiile tehnice necesare pentru operarea sigură și eficientă a rețelelor.",
        "werbemittelhover": "Westenergie Promotional Items Shop este o platformă online prin care angajații și partenerii autorizați ai grupului Westenergie pot comanda materiale promoționale și de comunicare.",
        "westenergie_brandhover": "Baza de date de imagini Westenergie, precum și elementele de brand și ghidurile de design ale grupului Westenergie. Acces la toate componentele brandului pentru a crea momente Westenergie. De la sistemul de management al brandului cu toate ghidurile importante pentru utilizarea elementelor de brand precum logo-uri, simboluri și chat box-ul nostru, până la biblioteca media cu numeroase imagini pentru toate variantele de design.",
        "compasshover": "Compass este platforma internă de comunicare la nivel de grup pentru știri & conținut E.ON, networking & schimb de experiență între angajați.",
        "gradarhover": "Acest instrument este folosit pentru a începe procesul de evaluare a posturilor pentru angajații de conducere.",
        "beqomhover": "Beqom este folosit la nivel de grup pentru administrarea și comunicarea planurilor de stimulente pe termen lung E.ON. Este utilizat de HR, Contabilitate, Taxe și Executivi. Pe lângă gestionarea planurilor de stimulente, beqom poate fi folosit și pentru crearea scrisorilor de plată și bonus și a declarațiilor de recompensă totală.",
        "kychover": "Cu instrumentul Know-Your-Counterpart (KYC) poți verifica partenerii conform politicilor standard (de ex.: PG-03).",
        "talentryhover": "Folosește această oportunitate pentru a împărtăși posturile noastre vacante cu persoane talentate din rețeaua ta – persoane care vor să contribuie la viitor cu energia lor.",
        "samhover": "Poți efectua instruiri obligatorii de siguranță cu acest instrument.",
        "enormhover": "e-NORM este un software puternic pentru gestionarea, furnizarea și actualizarea datelor legate de asigurarea calității sau documente standard, precum și pentru legarea fișierelor asociate.",
        "redonlinehover": "Red-on-line (ROL) Compliance Monitor simplifică gestionarea conformității reglementărilor, oferind actualizări în timp real privind reglementările de mediu, sănătate și siguranță (EHS). Dispune de monitorizare și dashboard-uri pentru a te ajuta să abordezi proactiv problemele de conformitate. Acest instrument este esențial pentru menținerea unui mediu de lucru sigur și conform, reducerea riscurilor și îmbunătățirea eficienței operaționale.",
        "tagetikcpmhover": "Aplicația Tagetik Corporate Performance Management (CPM) pentru bugetare & planificare, consolidare, raportare de risc și management (introdusă de Finance Excellence) a E.ON SE (Group Reporting). Procesele principale sunt închiderile trimestriale cu impact extern ridicat datorită termenului limită pentru comunicarea pe piața de capital.",
        "tagetikcpmermhover": "Aplicația Tagetik Corporate Performance Management (CPM) și Enterprise Risk Management (ERM) pentru bugetare & planificare, consolidare, raportare de risc și management (introdusă de Finance Excellence) a E.ON SE (Group Reporting). Procesele principale sunt închiderile trimestriale cu impact extern ridicat datorită termenului limită pentru comunicarea pe piața de capital.",
        "smartguidehover": "Smart Guide Hub este un wiki care va fi întreținut editorial de câțiva colegi pentru a furniza politici pentru aproximativ 4000 de utilizatori în domeniile IFRS, Controlling, HGB și ESG.",
        "tagetiksachover": "Tagetik Dashboard. Tagetik este o aplicație pentru bugetare & planificare, consolidare, raportare de risc și management (introdusă de Finance Excellence) a E.ON SE (Group Reporting). Procesele principale sunt închiderile trimestriale cu impact extern ridicat datorită termenului limită pentru comunicarea pe piața de capital.",
        "myithover": "Punctul tău de referință pentru orice legat de IT: opțiuni de suport, link-uri utile, comunități și ultimele noutăți pe care trebuie să le cunoști despre IT.",
        "SailPoint": "Identity Management Overview",
        "P29": "SAP EIC",
        "P83": "SAP EIC",
        "BIC": "BIC Cloud / BIC Process Design",
        "Celonis": "Celonis Process Mining",
        "Carsync": "Carsync Fuhrparkmanagement",
        "ISUSpace": "ISU/Space",
        "GNIS": "GNIS (EDI)",
        "ecount_EDI": "ecount EDI",
        "SAP_Datasphere_EDI": "SAP Datasphere EDI",
        "SailPointhover": "Cu SailPoint pot fi gestionate central drepturile de acces și identitățile.",
        "P29hover": "Cu SAP EIC, tichetele și solicitările clienților pot fi gestionate și documentate eficient. Aplicația suportă schimbul de date cu ECG și oferă o interfață centralizată pentru gestionarea tichetelor.",
        "P83hover": "Cu SAP EIC, tichetele și solicitările clienților pot fi gestionate și documentate eficient. Aplicația suportă schimbul de date cu ECG și oferă o interfață centralizată pentru gestionarea tichetelor.",
        "BIChover": "Cu BIC Cloud, procesele de afaceri pot fi modelate, analizate și optimizate.",
        "Celonishover": "Process Mining: Analiza proceselor reale pe baza jurnalelor de evenimente din sistemele ERP, CRM și altele. Execution Management: Automatizarea fluxurilor de lucru și a recomandărilor de acțiune. Optimizarea proceselor: Identificarea ineficiențelor, de exemplu, în procesele Purchase-to-Pay sau Order-to-Cash. Integrare: Conectare la sisteme precum SAP, Salesforce, Oracle etc.",
        "Carsynchover": "Cu Carsync pot fi gestionate eficient mașinile de serviciu și flotele auto, documentate deplasările și optimizate costurile.",
        "ISUSpacehover": "Cu ISU/Space pot fi rezervate și gestionate ușor locurile de muncă și sălile de ședință.",
        "GNIShover": "Cu GNIS pot fi gestionate și schimbate eficient datele master și cele de rețea pentru comunicarea de piață (EDI).",
        "ecount_EDIhover": "Cu eccount pot fi gestionate, schimbate și analizate datele master și cele de rețea relevante pentru EDI.",
        "SAP_Datasphere_EDIhover": "Cu SAP Datasphere pot fi integrate, modelate și puse la dispoziție date din diverse surse pentru analiză și decizii de afaceri. Platforma suportă self-service, guvernanță a datelor și acces în timp real la date.",
        "servicehub": "Service Hub",
        "servicehubhover": "With EON Service Hub, you can easily request new software and hardware including laptops and monitors, and get IT support by raising issues or chatting with the my IT support, all in one place.",
        "ukhr": "UK HR App",
        "ukhrhover": "Your one stop shop for everything UK HR. From payslips to holiday booking and everything in between. Get started with our employee and manager guides or search all of HR below.",
        "CFLP": "CFLP",
        "corporateWorkspace": "Corporate Workspace",
        "SAPWebLaunchpad": "SAP Web Launchpad",
        "CFLPhover": "Punct central de acces pentru sistemele SAP și serviciile cloud.",
        "corporateWorkspacehover": "SAP Build Work Zone, Advanced Edition vă permite să creați soluții de spațiu de lucru digital pentru a crește productivitatea și implicarea utilizatorilor. Centralizează accesul la aplicații de afaceri relevante, procese, informații și comunicare într-un singur punct de acces, accesibil de pe orice dispozitiv.",
        "SAPWebLaunchpadhover": "SAP Web Launchpad oferă acces la sistemele SAP prin web folosind Fiori și WebGUI. Pagina de start personalizabilă, inclusiv favoritele, permite acces rapid la sistemele SAP și clienți.",
        "PKI_Semnatura_Digitala_6781": "PKI - Semnatura Digitala",
        "Users_Access_EER_9163": "RAPPS EER",
        "Evaluare_Personal_EER_2935": "Evaluare Personal EER",
        "Sesizari_Administrare_Cladiri_EER_8543": "Sesizari Administrare Cladiri EER",
        "MRBS_EER_8445": "MRBS EER",
        "Delegatii_EER_1137": "Delegatii EER",
        "Users_Access_EER_5369": "Users Access EER",
        "Planificare_Concedii_EER_8588": "Planificare Concedii EER",
        "Pontaje_si_Telemunca_EER_7087": "Pontaje si Telemunca EER",
        "BOT_6231": "BOT",
        "Bonusare_personal_6879": "Bonusare personal",
        "GRC_Request_5510": "Cerere GRC",
        "iPEN_Portal_3047": "Portal iPEN",
        "YourVoiceEON_0693": "YourVoice@E.ON",
        "ITPortal_5530": "Portal IT (Süwag)",
        "Transf4m_Ticket_Tool_6635": "Transf4m Ticket Tool (Süwag)",
        "Speedikon_C_1281": "Speedikon C (Süwag)",
        "Speiseplan_8904": "Speiseplan (Süwag)",
        "Ariba_8690": "Ariba",
        "DiSch_20_0545": "DiSch 2.0",
        "ISMSMeldezentrale_9318": "ISMS-Meldezentrale (Süwag)",
        "SAP_Launchpad_8736": "SAP Launchpad (Süwag)",
        "HR_Portal_3311": "HR Portal (Süwag)",
        "Confluence_9100": "Confluence (Süwag)",
        "my_IT_order_6623": "my IT order",
        "BAT_Business_Activity_Tracker_7022": "BAT PL",
        "CTP_2407": "CTP PL",
        "BPM_OSD_PL_5209": "BPM OSD PL",
        "jflow_PL_6875": "jflow PL",
        "Qmatic_PL_CS_3195": "Qmatic PL CS",
        "Qmatic_PL_EN_3118": "Qmatic PL EN",
        "CCM_Inspire_7264": "CCM Inspire",
        "Atoss_artelisGruppe_und_VSEAgentur_3137": "Atoss artelis-Gruppe und VSE-Agentur",
        "Atoss_VSEGruppe_4374": "Atoss VSE-Gruppe",
        "AWS_Access_Portal_1318": "AWS Access Portal",
        "eDIVA_5372": "eDIVA",
        "G2G_VSEGruppe_6518": "G2G VSE-Gruppe",
        "AWS_Access_Portal_6740": "AWS Access Portal",
        "Qualys_Security_4331": "Qualys Security",
        "ODIN_FinOps_6411": "ODIN FinOps",
        "Cloudflare_4507": "Cloudflare",
        "ADP_TRAVEL_REISEMANAGEMENT_3368": "ADP TRAVEL REISEMANAGEMENT",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292": "Raportează un incident de securitate IT VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987": "Raportează un incident HSE VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571": "Meniu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367": "Formular de raportare IT VSE-Gruppe",
        "LeanIX_5372": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902": "VSE Wiki CONFLUENCE",
        "Young_Talents_AzubiPortal_3338": "Young Talents Azubi-Portal",
        "Workday_Peakon_eNPS_1749": "Workday Peakon eNPS",
        "Umantis_0386": "Umantis",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447": "Adeverințe și alte aplicații HR (RO CS)",
        "Deconturi_card_companie_RO_CS_5333": "Deconturi cu cardul companiei (RO CS)",
        "Documente_delegatii_RO_CS_5332": "Documente pentru delegații (RO CS)",
        "SAP_ISU_CS_RO_8555": "SAP IS-U CS RO",
        "PKI_Semnatura_Digitala_6781hover": "resetare token",
        "Users_Access_EER_9163hover": "RAPPS EER",
        "Evaluare_Personal_EER_2935hover": "Portal evaluare personal EER",
        "Sesizari_Administrare_Cladiri_EER_8543hover": "Portal sesizari Administrare Cladiri EER",
        "MRBS_EER_8445hover": "Rezervare sala de sedinte EER",
        "Delegatii_EER_1137hover": "Portal delegatii EER",
        "Users_Access_EER_5369hover": "Users access Form EER",
        "Planificare_Concedii_EER_8588hover": "Planificare Concedii EER",
        "Pontaje_si_Telemunca_EER_7087hover": "Pontaje si Telemunca EER",
        "BOT_6231hover": "Decontare bilete de odihna si tratament",
        "Bonusare_personal_6879hover": "Bonusare personal",
        "GRC_Request_5510hover": "GRC înseamnă Governance & Risk Compliance Access Control și este un instrument SAP Workflow pentru solicitarea, aprobarea și atribuirea automată a autorizațiilor utilizatorilor în sistemele SAP.",
        "iPEN_Portal_3047hover": "Information Platform of Energy Networks, pe scurt iPEN, asigură agregarea și furnizarea centralizată a datelor unităților regionale. Soluțiile inteligente existente și cele nou dezvoltate sunt conectate la platformă. Astfel, ele pot fi implementate rapid, flexibil și eficient din punct de vedere al costurilor în întreaga comunitate de rețea. Prin urmare, iPEN este facilitatorul central pentru scalarea soluțiilor inteligente.",
        "YourVoiceEON_0693hover": "Platforma PEAKON îți trimite o dată pe săptămână aproximativ 4-5 întrebări legate de starea ta de bine și de situația ta actuală la locul de muncă. Poți evalua întrebările (de la 0 la 10), le poți comenta sau le poți sări. Răspunsul la aceste câteva întrebări durează doar aproximativ 1-2 minute.",
        "ITPortal_5530hover": "Portalul de servicii IT al Süwag",
        "Transf4m_Ticket_Tool_6635hover": "Transf4m Ticket Tool",
        "Speedikon_C_1281hover": "Speedikon C",
        "Speiseplan_8904hover": "Meniu",
        "Ariba_8690hover": "Portal de achiziții",
        "DiSch_20_0545hover": "Acesta este locul meu de munca digital",
        "ISMSMeldezentrale_9318hover": "ISMS-Meldezentrale",
        "SAP_Launchpad_8736hover": "SAP Launchpad",
        "HR_Portal_3311hover": "HR Portal",
        "Confluence_9100hover": "Confluence al Süwag",
        "my_IT_order_6623hover": "my IT order",
        "BAT_Business_Activity_Tracker_7022hover": "Raportarea timpului",
        "CTP_2407hover": "CTP (Timpul înseamnă bani)",
        "BPM_OSD_PL_5209hover": "BPM PP + CRM DSO",
        "jflow_PL_6875hover": "Suport pentru procesarea proceselor de afaceri cu Jira",
        "Qmatic_PL_CS_3195hover": "Aplicație pentru gestionarea fluxului de clienți (cozi) în punctele de vânzare (POS)",
        "Qmatic_PL_EN_3118hover": "Aplicație pentru gestionarea fluxului de clienți (cozi) în punctele de vânzare (POS)",
        "CCM_Inspire_7264hover": "Platforma centralizată E.ON pentru managementul comunicării cu clienții (CCM), susținută de Quadient Inspire, pentru crearea și livrarea comunicărilor către clienți.",
        "Atoss_artelisGruppe_und_VSEAgentur_3137hover": "Acesta este sistemul nostru de pontaj",
        "Atoss_VSEGruppe_4374hover": "Acesta este sistemul nostru de pontaj",
        "AWS_Access_Portal_1318hover": "Acces la conturile AWS",
        "eDIVA_5372hover": "Administrarea utilizatorilor ANF",
        "G2G_VSEGruppe_6518hover": "Sistemul GIS al VSE-Gruppe",
        "AWS_Access_Portal_6740hover": "Acces la Cloud AWS VSE-Gruppe",
        "Qualys_Security_4331hover": "Monitorizarea riscurilor la nivel de companie",
        "ODIN_FinOps_6411hover": "ODIN FinOps VSE-Gruppe",
        "Cloudflare_4507hover": "Cloudflare VSE-Gruppe",
        "ADP_TRAVEL_REISEMANAGEMENT_3368hover": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
        "ITSicherheitsvorfall_melden_VSEGruppe_9292hover": "Raportează un incident de securitate IT VSE-Gruppe",
        "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987hover": "Raportează un incident HSE VSE-Gruppe",
        "Speiseplan_VSEGruppe_3571hover": "Meniu VSE-Gruppe",
        "ITMeldebogen_VSEGruppe_1367hover": "Formular de raportare IT VSE-Gruppe",
        "LeanIX_5372hover": "LeanIX",
        "VSE_Wiki_CONFLUENCE_1902hover": "Instrucțiuni",
        "Young_Talents_AzubiPortal_3338hover": "Young Talents Azubi-Portal VSE-Gruppe",
        "Workday_Peakon_eNPS_1749hover": "Workday Peakon eNPS",
        "Umantis_0386hover": "Umantis VSE-Gruppe",
        "Adeverinte_alte_aplicatii_HR_RO_CS_2447hover": "Scopul acestei aplicații este să permită fiecărui utilizator să descarce diferite tipuri de adeverințe în maximum trei clicuri. Aplicația oferă și funcții pentru administratorii HR și coordonatorii de echipă, care pot descărca adeverințe pentru colegii aflați în coordonarea lor. În plus, angajații își pot calcula vechimea în muncă și ajutorul pentru pensionare și pot solicita alte documente de la departamentul HR.",
        "Deconturi_card_companie_RO_CS_5333hover": "Posesorii de carduri de companie pot trimite cu ușurință deconturile de cheltuieli prin această aplicație, fără să trimită bonurile prin e-mail sau poștă și fără să solicite aprobări prin e-mail. Întregul proces se desfășoară pe această platformă.",
        "Documente_delegatii_RO_CS_5332hover": "Aplicația de gestionare a delegațiilor le permite utilizatorilor să adauge documente la propriile delegații și la cele ale subordonaților. Administratorii HR pot vizualiza, filtra și închide documente în bloc și pot solicita documente suplimentare prin e-mailuri trimise automat.",
        "SAP_ISU_CS_RO_8555hover": "Serviciul acoperă activitățile legate de sistemele SAP IS-U x7G utilizate de E.ON RO CS.",
        "subTitle": {
            "PKI_Semnatura_Digitala_6781SubTitle": "Reinnoire/Rescriere token",
            "Users_Access_EER_9163subTitle": "RAPPS EER",
            "Evaluare_Personal_EER_2935subTitle": "Portal evaluare personal EER",
            "Sesizari_Administrare_Cladiri_EER_8543subTitle": "Portal sesizari Administrare Cladiri EER",
            "MRBS_EER_8445subTitle": "Rezervare sala de sedinte EER",
            "Delegatii_EER_1137subTitle": "Portal delegatii EER",
            "Users_Access_EER_5369subTitle": "Users access Form EER",
            "Planificare_Concedii_EER_8588subTitle": "Planificare Concedii EER",
            "Pontaje_si_Telemunca_EER_7087subTitle": "Pontaje si Telemunca EER",
            "BOT_6231subTitle": "Decontare bilete de odihna si tratament",
            "Bonusare_personal_6879subTitle": "Bonusare personal",
            "GRC_Request_5510SubTitle": "Cerere GRC",
            "iPEN_Portal_3047SubTitle": "Platforma de informații a rețelelor energetice",
            "YourVoiceEON_0693SubTitle": "YourVoice@E.ON",
            "ITPortal_5530SubTitle": "Süwag",
            "Transf4m_Ticket_Tool_6635SubTitle": "JIRA",
            "Speedikon_C_1281SubTitle": "Rezervare locuri de lucru",
            "Speiseplan_8904SubTitle": "Höchst",
            "Ariba_8690SubTitle": "Portal de achiziții",
            "DiSch_20_0545SubTitle": "Loc de munca digital",
            "ISMSMeldezentrale_9318SubTitle": "Süwag",
            "SAP_Launchpad_8736SubTitle": "WEB",
            "HR_Portal_3311SubTitle": "Selfservices",
            "Confluence_9100SubTitle": "Süwag",
            "my_IT_order_6623SubTitle": "E.ON",
            "BAT_Business_Activity_Tracker_7022SubTitle": "Urmărirea activității de afaceri",
            "CTP_2407SubTitle": "Czas to pieniądz",
            "BPM_OSD_PL_5209SubTitle": "BPM PP + CRM DSO",
            "jflow_PL_6875SubTitle": "Procesarea proceselor de afaceri",
            "Qmatic_PL_CS_3195SubTitle": "Qmatic E.ON Polska",
            "Qmatic_PL_EN_3118SubTitle": "Qmatic Stoen Operator",
            "CCM_Inspire_7264SubTitle": "CCM - Platformă",
            "Atoss_artelisGruppe_und_VSEAgentur_3137SubTitle": "artelis-Gruppe und VSE-Agentur",
            "Atoss_VSEGruppe_4374SubTitle": "Atoss VSE-Gruppe",
            "AWS_Access_Portal_1318SubTitle": "IT - CloudCore",
            "eDIVA_5372SubTitle": "eDIVA Administrarea utilizatorilor ANF -> eDIVA",
            "G2G_VSEGruppe_6518SubTitle": "G2G VSE-Gruppe",
            "AWS_Access_Portal_6740SubTitle": "AWS Access Portal VSE-Gruppe",
            "Qualys_Security_4331SubTitle": "Qualys Security VSE-Gruppe",
            "ODIN_FinOps_6411SubTitle": "ODIN FinOps VSE-Gruppe",
            "Cloudflare_4507SubTitle": "Cloudflare VSE-Gruppe",
            "ADP_TRAVEL_REISEMANAGEMENT_3368SubTitle": "ADP TRAVEL REISEMANAGEMENT  VSE-Gruppe",
            "ITSicherheitsvorfall_melden_VSEGruppe_9292SubTitle": "Raportează un incident de securitate IT VSE-Gruppe",
            "HSE_Sicherheitsvorfall_melden_VSEGruppe_9987SubTitle": "Raportează un incident HSE VSE-Gruppe",
            "Speiseplan_VSEGruppe_3571SubTitle": "Meniu VSE-Gruppe",
            "ITMeldebogen_VSEGruppe_1367SubTitle": "Formular de raportare IT VSE-Gruppe",
            "LeanIX_5372SubTitle": "LeanIX",
            "VSE_Wiki_CONFLUENCE_1902SubTitle": "VSE Wiki CONFLUENCE",
            "Young_Talents_AzubiPortal_3338SubTitle": "Young Talents Azubi-Portal VSE-Gruppe",
            "Workday_Peakon_eNPS_1749SubTitle": "Workday Peakon eNPS",
            "Umantis_0386SubTitle": "Umantis VSE-Gruppe",
            "Adeverinte_alte_aplicatii_HR_RO_CS_2447SubTitle": "Adeverințe și alte aplicații HR (RO CS)",
            "Deconturi_card_companie_RO_CS_5333SubTitle": "Deconturi cu cardul companiei (RO CS)",
            "Documente_delegatii_RO_CS_5332SubTitle": "Documente pentru delegații (RO CS)",
            "SAP_ISU_CS_RO_8555SubTitle": "SAP IS-U CS RO",
            "CFLPSubTitle": "Fiori Launchpad Central",
            "corporateWorkspaceSubTitle": "SAP Build Work Zone, Advanced Edition",
            "SAPWebLaunchpadSubTitle": "Linkuri către sistemele SAP",
            "timeSubTitle": "CATS",
            "meetingSubTitle": "GINGCO",
            "approvalSubTitle": "SNOW/SAP",
            "prSubTitle": "BANF",
            "praSubTitle": "BANF",
            "processingSubTitle": "SAP",
            "hrSubTitle": "MyHR",
            "concurSubTitle": "SAP Concur",
            "passwordSubTitle": "SAP Systems",
            "aribaSubTitle": "PO Overview",
            "itresourcesSubTitle": "SNOW",
            "incidentSubTitle": "SNOW",
            "orderSubTitle": "Serviciiclegate de comezi IT",
            "myassetsSubTitle": "SNOW",
            "beelineSubTitle": "Angajări externe",
            "prismaSubTitle": "HSE",
            "gertrudSubTitle": "Pregătirea ședințelor consiliului de administrație",
            "notificationSubTitle": "Servicii de întreținere și administrare",
            "zukoSubTitle": "Organizarea mutării birourilor",
            "eon_brandSubTitle": "it's on us",
            "pkiSubTitle": "Managementul certificatelor",
            "mailSubTitle": "Întreținere",
            "journeySubTitle": "FuV §37b EstG",
            "mygeniusSubTitle": "Platforma de învățare digitală",
            "ideeonSubTitle": "Ideenmanagement",
            "ideenetSubTitle": "Ideenmanagement",
            "dpfSubTitle": "Fisiere Personal Digitale",
            "corpsacSubTitle": "SAC",
            "corpportalSubTitle": "Portal Corporate",
            "redwoodSubTitle": "Redwood FA",
            "eamsap200SubTitle": "SAP Cloud Cockpits (200)",
            "eamsap100SubTitle": "SAP Cloud Cockpits (100)",
            "sodsapSubTitle": "SoD-Portal",
            "videonSubTitle": "VidEON",
            "alteryxSubTitle": "Alteryx",
            "ebamSubTitle": "EBAM",
            "egsSubTitle": "EGS",
            "epsnextSubTitle": "EPSnext",
            "fisquantumSubTitle": "FIS Quantum",
            "rmsSubTitle": "RMS",
            "slidoSubTitle": "Slido",
            "insightslibrarySubTitle": "Arhiva de informații utile",
            "getabstractSubTitle": "Biblioteca Online",
            "mypotentialSubTitle": "AMP",
            "dsesoftwareSubTitle": "DSE",
            "whistleblowingSubTitle": "E.ON Sistem de avertizare internă",
            "maqsimaSubTitle": "Managementul evaluărilor de risc",
            "digitalrulebookSubTitle": "Directiva Grupului",
            "oneERPSubTitle": "EAM/ESM",
            "PerseusSubTitle": "Perseus",
            "cateringportalSubTitle": "Portal Catering",
            "westnetzregelwerkeSubTitle": "nScale",
            "werbemittelSubTitle": "Werbemittelshop",
            "westenergie_brandSubTitle": "Westenergie Frontify",
            "compassSubTitle": "Platform de comunicare interna la nivel de grup",
            "gradarSubTitle": "Evaluarea locurilor de muncă și compensația",
            "beqomSubTitle": "beqom",
            "kycSubTitle": "Verificarea conformității părților",
            "talentrySubTitle": "Program de recomandare a locurilor de muncă",
            "samSubTitle": "Instruire în domeniul siguranței @E.On",
            "enormSubTitle": "Sistem de monitorizare a conformității",
            "redonlineSubTitle": "red-on-line",
            "tagetikcpmSubTitle": "CPM",
            "tagetikcpmermSubTitle": "CPM and ERM",
            "smartguideSubTitle": "Smart Guide Hub (Wiki de contabilitate)",
            "tagetiksacSubTitle": "Tagetik SAP Analytics Cloud",
            "myitSubTitle": "Suport IT și știri",
            "SailPointSubTitle": "Prezentare generală a managementului identității și accesului",
            "P29SubTitle": "SAP EIC",
            "P83SubTitle": "SAP P83",
            "BICSubTitle": "BIC Cloud",
            "CelonisSubTitle": "Minerit de procese",
            "CarsyncSubTitle": "Managementul flotei auto",
            "ISUSpaceSubTitle": "Administrarea spațiilor și locurilor de muncă",
            "GNISSubTitle": "Managementul datelor master EDI",
            "ecount_EDISubTitle": "Managementul datelor EDI",
            "SAP_Datasphere_EDISubTitle": "Integrarea datelor și structura datelor de afaceri",
            "servicehubSubTitle": "Service Hub",
            "ukhrSubTitle": "UK HR App"
        }
    },
    "searchPage": {
        "searchPlaceholder": "Cauta...",
        "searchApps": "Cauta aici...",
        "relatedApps": "Aplicatii",
        "viewMoreApps": "Mai mult",
        "removeAppTooltip": "Elimina de pe Dashboard",
        "addAppTooltip": "Adauga pe Dashboard",
        "addedAppTooltip": "Adaugat pe Dashboard"
    },
    "pwaText": {
        "header": "Instaleaza această aplicație pe ecranul <b>principal</b>!",
        "button": "Instaleaza aplicația",
        "iphoneHeader": "Pentru a instala această aplicație pe iPhone",
        "inst1": "Apasă pe butonul <b>Share</b> în Safari.",
        "inst2": "Derulează în jos și selectează <b>\"Adaugă pe ecranul principal\".</b>",
        "inst3": "Apasă <b>Adaugă</b> în colțul din dreapta sus."
    },
    "filterPage": {
        "filterMenu": {
            "backBtn": "Înapoi la pagina anterioară",
            "enterSearchTerm": "Introdu cuvântul cheie de căutare și filtrează rezultatele",
            "disclaimer": "Unele rezultate pot să nu fie complet relevante. Te rugăm să revizuiești cu atenție.",
            "loading": "Se incarca",
            "app": "Aplicații",
            "gitlab": "Gitlab",
            "apps": "Aplicații",
            "all": "Toate",
            "m365": "Fișierele mele",
            "jql": "jql",
            "people": "Persoane",
            "emails": "Email-urile mele",
            "teams": "Teams",
            "community": "Communitate",
            "pages": "Pagini",
            "users": "Utilizatori",
            "noData": "Nu am putut gasi rezultate pentru",
            "noMoreData": "Nu am gasit rezultate suplimentare pentru cautarea ta!",
            "filterHeading": "Filtre",
            "reset": "Resetare filtre",
            "refineResults": "Rafinare rezultate",
            "card_languages": "Setari Limba",
            "ecl_source_name": "Sursa",
            "standard_card_type": "Tip",
            "mimeType": "Tip",
            "datasources": "Surse de date",
            "lookingFor": "Caut ceva",
            "timeRange": "Interval orar",
            "department": "Departament",
            "mygenius": "My Genius",
            "jira": "Jira",
            "confluence": "Confluence",
            "orderit": "My IT order",
            "aiAssistant": "Asistent AI",
            "space": "Spațiu",
            "time": "Timp",
            "priority": "Prioritate",
            "status": "Status",
            "compass": "Compass",
            "categoryTags": "Categorie",
            "kb_articles": "Suport IT",
            "officeBuddy": "Platforma de informatii E.ON",
            "key": "Project",
            "companyTags": "Unitate de afaceri",
            "searchIn": "Căutare în"
        },
        "searchResult": {
            "source": "Sursa",
            "business": "Business",
            "mobile": "Mobil",
            "type": "Tip",
            "duration": "Durata",
            "category": "Categorie",
            "deliveryTime": "Timp de livrare",
            "availableLanguages": "Limbi disponibile",
            "status": "Status",
            "lastUpdate": "Ultima actualizare",
            "lastUpdated": "Ultima actualizare",
            "createdOn": "Creat la",
            "createdBy": "Creat de",
            "company": "Companie",
            "department": "Departament",
            "job_title": "Numele postului",
            "office_location": "Locația biroului",
            "email": "Email",
            "preview": "Previzualizare",
            "viewEmail": "Vezi Email"
        },
        "timeRangeOptions": {
            "All": "Toate",
            "yesterday": "O Zi",
            "lastWeek": "7 Zile",
            "lastMonth": "O Luna",
            "6 Months": "6 Luni",
            "lastYear": "Un An"
        },
        "dataSources": {
            "Confluence": "Confluence",
            "Gitlab": "Gitlab",
            "JIRA": "Jira",
            "MyGenius": "MyGenius",
            "ItOrder": "my IT order",
            "Sharepoint": "SharePoint",
            "Knowledge Base": "Knowledge Base",
            "powerpoint": "PowerPoint",
            "word": "Word",
            "excel": "Excel",
            "pdf": "PDF",
            "loop": "Loop",
            "other": "Alta"
        },
        "searchOptions": {
            "local": "<BU>",
            "compassWide": "Toate unitățile de afaceri"
        },
        "searchOptionsHover": "Afișează conținut din unitatea ta de business, conținutul grupului E.ON sau conținut din alte unități de business."
    },
    "chatBot": {
        "dislikeDialog": {
            "title": "Trimite feedback",
            "irrelevant": "Răspunsul nu a fost relevant",
            "incorrect": "Informațiile au fost incorecte",
            "detail": "Răspunsul nu a avut suficiente detalii",
            "other": "Altele",
            "comments": "Comentarii suplimentare",
            "placeholder": "Spune-ne mai multe despre feedback-ul tău (opțional)",
            "later": "Poate mai târziu",
            "submit": "Trimite feedback",
            "error": "Feedback-ul nu a putut fi trimis. Încearcă din nou."
        },
        "chatIcon": "ChatBot",
        "contactNumberPlaceholder": "Numar de contact cu codul tarii",
        "incidentDetailsLabel": "Rezume e incidentosqo",
        "contactNumberLabel": "Vă rugăm să introduceți numărul de contact preferat",
        "sourceName": "Sursa",
        "searchBack": "Inapoi la pagina anterioara",
        "welcomeMessage": "Incepe conversatia ",
        "chatbotPlaceholder": "Scrie aici...",
        "sendbtn": "Trimite",
        "showMore": "Arata mai mult",
        "showMoreTooltip": "Arata raspunsul complet",
        "showLess": "Arata mai putin",
        "showLessTooltip": "Minimizeaza complet raspunsul",
        "continueAssistance": "Continua cu Asistentul AI",
        "continueAssistanceTooltip": "Continua cu Asistentul AI pentru a pune intrebari suplimentare",
        "feedbackTitle": "A fost util?",
        "feedbackThumbsUpLabel": "Da, m-a ajutat",
        "feedbackThumbsDownLabel": "Inca am nevoie de ajutor?",
        "feedbackPrompt": "Feedback-ul tau aici",
        "askMe": "Intreaba-ma",
        "imageUpload": "Incarca imagine",
        "uploadImageTooltip": "Incarca imagine si intreaba.",
        "uploadImageFormat": "Format acceptat: JPG/PNG",
        "uploadImageProcessing": "Se proceseaza imaginea...",
        "uploadImageQuestions": "Intrebari sugerate:",
        "card": {
            "selfService": "Acces la servicii",
            "efficiency": "Eficienta",
            "ngService": "Servicii Next-Gen"
        },
        "disclaimerText": "Reține că toate răspunsurile sunt generate de AI și pot conține erori.",
        "selfServiceTitle": "Suport IT",
        "selfServiceContent": "Suport pentru rezolvarea incidentelor de serviciu rapid, activat de AI",
        "knowledgeBaseTitle": "Knowledge Base",
        "knowledgeBaseContent": "Imbunatatirea experientei angajatilor cu ajutorul informatiilor",
        "internetSearchTitle": "Intrebari generale",
        "wentWell": "Ce a mers bine? (optional)",
        "wentWrong": "Ce nu a mers bine?",
        "privacyMsg": "Respectam confidentialitatea si ne asiguram ca feedback-urile vor fi tratate in mod confidential.",
        "appreciateService": "Apreciem ajutorul dumneavoastra in imbunatatirea serviciilor noastre.",
        "feedbackMessage": "Multumim pentru feedback-ul dumneavoastra!",
        "relevantSearches": "Cautari cele mai relevante",
        "aiAssitanceSuggestion": "Puteti adresa intrebarile dumneavoastra Asistentei AI folosind caseta de introducere de mai jos",
        "aiActionMsg": "Se pare ca stocarea interna este plina. Pot sa va ajut sa rezolvati problema de instalare curatand automat fisierele temporare si golind cosul de reciclare. Doriti sa fac curatenie automat?",
        "aiActionPrimaryBtn": "Curata automat",
        "aiActionSecondaryBtn": "Nu curata automat",
        "aiActionSuccess": "Stocarea dumneavoastra a fost curatata.",
        "aiActionFailed": "Ceva a mers prost. Va rugam sa incercati din nou mai tarziu. Sau va rugam sa incercati manual.",
        "hey": "Hey",
        "topicStartMessage": "cu ce problemă IT te pot ajuta astăzi?",
        "commonItIssues": "Probleme IT frecvente",
        "newChat": "Chat nou",
        "search": "E.ON Search",
        "open": "Deschide",
        "close": "Inchide",
        "recentChats": "Chat-uri recente",
        "ask": "Intreaba",
        "internet": "Internet",
        "askEon": "Intreaba E.ON",
        "askInternet": "Intreaba Internet",
        "askFollowUpQuestion": "Intreaba o intrebare suplimentara",
        "resolveIssue": "Trimiterea feedback-ului va activa activitati de suport",
        "resolveIssueAfterFeedback": "Imi pare rau, nu am putut rezolva problema dumneavoastra. Cu ce va pot ajuta in continuare?",
        "differentiator": "sau",
        "incident": "Creare tichet de serviciu",
        "creatingIncident": "Crearea unui incident",
        "liveAgent": "Chat cu un agent",
        "requestCallbackBtn": "Solicita apelare pentru asistenta in continuare",
        "ticketDescription": "Descrierea tichetului bazata pe baza discutiei recente",
        "createIncident": "Creare incident",
        "confirmCreateIncident": "Confirma si creeaza incident",
        "editCreateIncident": "Editeaza si creeaza incident",
        "ticketSuccessMsg": "Incidentul dumneavoastra a fost inregistrat cu succes, Numărul tichetului: ",
        "ticketErrorMsg": "Ceva nu a functionat. Va rugam sa incercati din nou mai tarziu.",
        "chatBotTitle": "Folositi asistentul MyHelp pentru a adresa o intrebare, a obtine suport si informatii utile din surse interne si externe.",
        "duplicateError": "Intrebare identica, va rugam sa adresati o intrebare diferita",
        "content": "Continut",
        "tone": "Ton",
        "information": "Informatii",
        "complete": "Complet",
        "other": "Altele",
        "irelevantContent": "Continut irelevant",
        "lackOfDetail": "Lipsa detalii",
        "incorrectInformation": "Informatii incorecte",
        "copyLink": "Copiaza Link",
        "openLink": "Deschide Link",
        "internetSearchContent": "Bazat pe intreaba-ma orice, EON gpt",
        "assignmentGroupForTicket": "eon-uk-gsd",
        "copy": "Copiaza",
        "share": "Partajeaza",
        "copiedMsg": "Copiat cu succes",
        "copyLinkMsg": "Copiaza Link",
        "sharableLink": "Link partajabil",
        "uploadImage": "Incarca imagine si adreseaza o intrebare",
        "liveAgentChat": {
            "connectWithLiveAgent": "Conecteaza-te cu my IT support",
            "connectingWithLiveAgent": "Se conecteaza cu my IT support",
            "connectingHint": "Te poti intoarce la asistenta facand clic pe linkul de mai jos in zona de chat",
            "agentLeftMsg": "Multumim ca ai contactat E.ON",
            "switchToAssistance": "Iesi din chat si comuta la asistenta",
            "typeMessageHint": "Scrie mesajul tau aici...",
            "disconnectingMsg": "Iesind din chat si comutand la asistenta",
            "continue": "Continua",
            "exitChat": "Iesi din chat",
            "chatSessionEndPrompt": "Sesiunea de chat se va incheia in <timer>"
        },
        "requestCallback": {
            "languageConfirmation": "Asistenta MyHelp a detectat ca limba ta implicita este “<language>”. Confirma pentru a te conecta cu un agent sau modifica limba dorita si tipul de agent mai jos.",
            "channelsText": "Primeste apel de revenire prin",
            "languageText": "Limba de comunicare",
            "channelLabel": "Selecteaza canalul",
            "phoneLabel": "Conecteaza-ma prin",
            "languageLabel": "Selecteaza limba",
            "tryAgain": "Incearca din nou",
            "technicalIssue": "Nu am putut finaliza apelul de revenire din cauza unei probleme tehnice. Te rugam sa incerci din nou.",
            "newNumber": "Numar nou",
            "availableMobileNumbers": "Numere de telefon mobile disponibile",
            "chosenNumber": "Conecteaza-ma pe acest numar de telefon",
            "phoneError": "Te rugam sa introduci un numar de contact valid",
            "referenceNumber": "Numar de referinta",
            "tooltip": {
                "confirmBtn": "Confirma pentru a plasa o cerere de apel de revenire",
                "resetBtn": "Reseteaza formularul pentru a sterge toate selectiile si a incepe din nou",
                "cancelBtn": "Anuleaza apelul de revenire"
            },
            "addNewNumber": "număr nou"
        },
        "quickActions": {
            "heading": "my IT support",
            "actions": {
                "createIncident": "Creează tichet",
                "chatWithServiceDesk": "Pornește chat live",
                "requestCallback": "Primește un apel înapoi",
                "ongoingConversation": "Da, este parte din ultima mea conversatie.",
                "newConversation": "Nu. Am nevoie de ajutor pentru a rezolva o noua problema",
                "confirmAndCreateTicket": "Confirma si creeaza ticket",
                "cancelTicketCreation": "Anuleaza crearea ticketului",
                "confirmChatWithServiceDesk": "Confirma si conecteaza-te cu my IT support",
                "cancelChatWithServiceDesk": "Anuleaza chatul cu my IT support",
                "cancelRequestCallback": "Anuleaza cererea de apel de revenire",
                "confirmRequestCallback": "Confirma pentru a te conecta prin <channel> <phone> cu un agent my IT support in limba <language>"
            },
            "state": {
                "whatsTheIssue": "Ce problema incerci sa rezolvi?",
                "lastConversation": "Sigur, este problema parte din ultima conversatie?",
                "createIncidentLabel": "Esti pe cale sa raportezi un incident pentru",
                "cancelAck": "Am notat. Pot sa te ajut cu alta problema?",
                "chatWithServiceDeskLabel": "Esti pe cale sa te conectezi cu un agent my IT support",
                "createTicketLabel": "Confirma si creeaza ticket",
                "cancelTicketLabel": "Anuleaza crearea ticketului",
                "creatingIncidentTicket": "Creare ticket pentru incident",
                "ticketAttachment": "Vă rugăm să adăugați o captură de ecran a erorii sau problemei.",
                "ticketAttachmentTooltipInstruction": "Apăsați tasta Windows + Print Screen sau folosiți instrumentul de decupare pentru a captura imaginea.",
                "ticketAttachmentTooltipWarning": "Dimensiunea imaginii trebuie să fie mai mică de 5 MB.",
                "ticketAttachmentLabel": "Atașați o captură de ecran",
                "ticketAttachmentTitle": "Captură de ecran atașată pentru tichet",
                "ticketAttachmentError": "Nu se poate atașa fișierul selectat. Asigurați-vă că fișierul este în format JPG sau PNG și mai mic de 5 MB.",
                "ticketAttachmentErrorAction": "Încercați din nou",
                "ticketDescription": "Descriere ticket",
                "ticketNonITWarning": "Asistența nu a găsit cuvinte cheie pentru a identifica problema dvs. ca fiind legată de IT.",
                "ticketNonITWarningQuestion": "Doriți să creați un incident la my IT support pe baza conversației dvs. despre",
                "ticketNonITWarningRecommendationLabel": "Recomandare:",
                "ticketNonITWarningRecommendationText": "Dacă aveți o problemă care nu este legată de software sau hardware, puteți încerca să reformulați căutarea sau să puneți o întrebare suplimentară mai jos.",
                "connectWithServiceDeskLabel": "Confirma pentru a vorbi cu my IT support",
                "requestCallbackLabel": "Solicită un apel înapoi",
                "requestCallbackInQueuePhone": "Solicitarea dvs. de apel înapoi a fost trimisă. Veți fi contactat în aproximativ 5 minute la <strong><phone></strong>. Între timp, puteți continua să utilizați alte aplicații.",
                "requestCallbackInQueueTeams": "Solicitarea dvs. de apel înapoi a fost trimisă. Veți fi contactat în aproximativ 5 minute prin <strong>Microsoft Teams</strong>. Între timp, puteți continua să utilizați alte aplicații.",
                "requestCallbackFailed": "Nu am reusit sa finalizam cererea ta de apel de revenire din cauza unei probleme tehnice. Te rugam sa incerci din nou.",
                "requestCallbackPromptAnswer": "Esti pe cale sa soliciti un apel de revenire de la my IT support",
                "requestCallbackConfirmLabel": "Confirma pentru a solicita un apel de revenire"
            },
            "tooltips": {
                "createIncident": "Asistenta  prin rezolvarea unei probleme IT si crearea unui incident cu my IT support, daca este necesar",
                "chatWithServiceDesk": "Asistenta  prin rezolvarea unei probleme IT si contactarea my IT support prin chat, daca este necesar",
                "requestCallback": "Solicita un apel de revenire de la my IT support"
            }
        },
        "askTooltip": {
            "eon": "Gaseste informatii specifice companiei din surse interne",
            "internet": "Gaseste informatii din surse interne si externe, cum ar fi E.ON GPT"
        },
        "jiraIntegration": {
            "viewInJira": "Vizualizat in Jira",
            "responseHeading": "Aici gasesti sumarul tichetelor tale din Jira :",
            "responseSubheading": "Arata primele 15 inregistrari",
            "noResponse": "Se pare ca nu exista tichete JIRA disponibile pentru cererea ta in acest moment.",
            "supportedQuestionMsg": "Imi pare rau. Nu am inteles exact intrebarea ta. Poti te rog sa o reformulezi? Imi permit sa impartasesc cateva intrebari de exemplu pentru a te ajuta:"
        },
        "intune": {
            "selectDevice": "Selectează un dispozitiv",
            "changeBrowserHomePage": "Schimbă pagina de start a browserului",
            "fixWillBeApplied": "Remedierea va fi aplicata pe acest sistem",
            "confirm": "Confirmă",
            "fixThis": "Remediază",
            "enterDeviceName": "Introdu numele dispozitivului",
            "selectOrEnterDevice": "Te rugam sa selectezi un dispozitiv sau sa introduci numele dispozitivului.",
            "actionFailed": "Actiunea a esuat.",
            "working": "Se proceseaza...",
            "fixOnThis": "Aplică pe acest dispozitiv",
            "deviceLabel": "Dispozitiv",
            "lastActive": "Ultima activitate",
            "today": "Astazi",
            "yesterday": "Ieri",
            "daysAgo": "zile in urma",
            "deviceTypeLaptop": "Laptop",
            "deviceTypeDesktop": "Desktop",
            "deviceTypeVirtualMachine": "Masina virtuala",
            "deviceTypeUnknown": "Dispozitiv",
            "homepageBrowserChange": {
                "syncInstructions": "Modificarea va fi aplicata acum pe dispozitivul tau. Acest lucru poate dura aproximativ 90 de minute. Daca vrei sa grabesti procesul, poti initia o sincronizare manuala din Company Portal:\n1. Deschide Company Portal\n2. In partea de jos din stanga, apasa pe Settings, langa simbolul rotii dintate.\n3. Apoi apasa pe butonul albastru \"Synchronize\" si asteapta finalizarea sincronizarii.",
                "changeHomepageInstructions": "1. Apasa pe cele trei puncte (...) din coltul din dreapta sus.\n2. Selecteaza „Setari”.\n3. In meniul din stanga, selecteaza „Start, pagina de start si fila noua”.\n4. La „La pornire”, asigura-te ca „Deschide site-uri personalizate” este selectat/bifat.\n5. Apoi apasa pe „Adauga site”.\n6. Introdu adresa site-ului pe care vrei sa il setezi ca noua pagina de start in Microsoft Edge (de exemplu: https://compass.eon.com/).\n7. Apasa „Adauga”.\n\nDaca vrei sa elimini un site din pagina de start, apasa pe cele trei puncte (...) de langa site si apoi pe „Elimina”.",
                "policyDescription": "Organizația dvs. gestionează în prezent setările paginii de start a browserului prin politici de dispozitiv. Pentru a activa modificarea paginii de start, trebuie mai întâi să identificăm ce dispozitiv ar trebui să primească actualizarea politicii.",
                "deviceSelectedForPolicy": "selectat pentru deblocarea politicii paginii de start",
                "stepsForEdge": "Pași pentru a schimba pagina de start în browserul Microsoft Edge",
                "whatsNextTitle": "Ce urmează?",
                "whatsNextSubmitted": "O cerere de a permite pagina de start personalizabilă a fost trimisă în coada de politici a dispozitivului tău. ",
                "whatsNextSyncTime": "<strong>90 de minute</strong> timp mediu de sincronizare necesar pentru reîmprospătarea politicii în fundal. ",
                "whatsNextReturn": "Te rugăm să revii la setările browserului după 90 de minute și să urmezi pașii de mai jos. ",
                "homepageEnabled": "Acum poti schimba setarile paginii de start a browserului tau. Te rugam sa retii ca modificarea s-ar putea sa nu intre in vigoare imediat. Asteapta aproximativ 30 de minute pana la finalizarea sincronizarii, apoi inchide si redeschide Edge.",
                "homepageAlreadyEnabled": "Dispozitivul tau are deja schimbarea paginii de start activata. Mergi la setarile browserului si incearca din nou.",
                "homepageEnableFailed": "Nu am putut activa schimbarea paginii de start in acest moment. Te rugam sa incerci mai tarziu.",
                "homepageRemoved": "Dispozitivul a fost eliminat din grupul de politici pentru pagina de start."
            }
        },
        "nexthinkIntegration": {
            "failureMsg": "Oops! Ceva nu a functionat. Te rugam sa incerci din nou mai tarziu. Daca problema persista, te rugam sa raportezi o problema din Actiuni rapide.",
            "assistanceTask": "Activitate de suport",
            "myActions": "Actiunile Mele",
            "itReportTitle": "Aici poti gasi informatii despre eficienta energetica a sistemelor tale",
            "days": "Zile",
            "device": "Dispozitiv",
            "sinceRestarted": "de la repornire",
            "deviceRestartRecommendation": "Se recomanda repornirea imediata a dispozitivului",
            "deviceInCompliance": "Dispozitivul tau este conform",
            "energyConsumed": "Energie consumata in ultimele 7 zile",
            "coEmitted": "CO2 emis in ultimele 7 zile",
            "cacheActionMsg": "Te rugam sa repornesti browserul pentru ca modificarile sa aiba efect.",
            "diskClean": {
                "primaryBtn": "Da, curata-mi discul acum",
                "secondaryBtn": "Nu curata acum",
                "successMsg": "Discul tau a fost curatat",
                "successMsgOnList": "Discul tau a fost curatat",
                "failureMsg": "Discul tau nu a putut fi curatat in acest moment",
                "progressMsg": "Curatarea spatiului de stocare este in curs de desfasurare",
                "disclaimer": "Te rugam sa retii ca nu vom atinge datele tale personale sau de lucru. In timp ce curatarea are loc in fundal, te rugam sa te simti liber sa folosesti asistenta.",
                "acknowledgeQuery": "Pot efectua o curățare a discului pentru dvs. În timpul curățării discului, fișierele inutile, memorii cache sau jurnale vechi din sistem sunt eliminate. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "chromeCache": {
                "primaryBtn": "Da, curata cache-ul chrome acum",
                "secondaryBtn": "Nu curata cache-ul chrome acum",
                "successMsg": "Cache-ul tau chrome a fost curatat. Te rugam sa repornesti browserul pentru ca modificarile sa aiba efect.",
                "successMsgOnList": "Cache-ul tau chrome a fost curatat",
                "failureMsg": "Cache-ul tau chrome nu a putut fi curatat in acest moment",
                "progressMsg": "Curatarea cache-ului chrome este in curs de desfasurare",
                "disclaimer": "Te rugam sa retii ca nu vom atinge datele tale personale sau de lucru. In timp ce curatarea are loc in fundal, te rugam sa te simti liber sa folosesti asistenta.",
                "acknowledgeQuery": "Vă pot ajuta să ștergeți memoria cache a browserului. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "edgeCache": {
                "primaryBtn": "Da, curata cache-ul edge acum",
                "secondaryBtn": "Nu curata cache-ul edge acum",
                "successMsg": "Cache-ul tau edge a fost curatat. Te rugam sa repornesti browserul pentru ca modificarile sa aiba efect.",
                "successMsgOnList": "Cache-ul tau edge a fost curatat",
                "failureMsg": "Cache-ul tau edge nu a putut fi curatat in acest moment",
                "progressMsg": "Curatarea cache-ului edge este in curs de desfasurare",
                "disclaimer": "Te rugam sa retii ca nu vom atinge datele tale personale sau de lucru. In timp ce curatarea are loc in fundal, te rugam sa te simti liber sa folosesti asistenta.",
                "acknowledgeQuery": "Vă pot ajuta să ștergeți memoria cache a browserului. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "empowerPlugin": {
                "progressMsg": "Solicitarea pentru pluginul Empower este în curs",
                "successMsgOnList": "Solicitarea pentru pluginul Empower a fost finalizată",
                "failureMsg": "Solicitarea pentru pluginul Empower nu a putut fi finalizată"
            },
            "empowerApp": {
                "primaryBtn": "Da, te rugam sa repari acum",
                "secondaryBtn": "Nu repara acum",
                "successMsg": "Reparatia automata a fost finalizata cu succes",
                "successMsgOnList": "Reparatia automata a fost finalizata cu succes",
                "failureMsg": "Pluginul tau Empower nu a putut fi reparat in acest moment",
                "progressMsg": "Reparatia automata este in curs de desfasurare",
                "disclaimer": "Vom reinstala pluginul Empower, te rugam sa inchizi toate aplicatiile tale O365 inainte de a continua.",
                "acknowledgeQuery": "Vă pot ajuta cu problemele legate de suplimentul Empower. Vă rugăm să faceți clic mai jos pentru a repara pluginul Empower."
            },
            "teamsCache": {
                "primaryBtn": "Da, curata cache-ul Teams acum",
                "secondaryBtn": "Nu curata cache-ul Teams acum",
                "successMsg": "Cache-ul tau Teams a fost curatat",
                "successMsgOnList": "Cache-ul tau Teams a fost curatat",
                "failureMsg": "Cache-ul tau Teams nu a putut fi curatat in acest moment",
                "progressMsg": "Curatarea cache-ului Teams este in curs de desfasurare",
                "disclaimer": "Te rugam sa retii ca nu vom atinge datele tale personale sau de lucru. In timp ce curatarea are loc in fundal, te rugam sa te simti liber sa folosesti asistenta.",
                "acknowledgeQuery": "Vă pot ajuta să ștergeți memoria cache pentru Teams. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "teamsReinstall": {
                "primaryBtn": "Da, reinstaleaza Teams",
                "secondaryBtn": "Nu reinstaleaza Teams",
                "successMsg": "Reinstalarea aplicatiei Teams a fost finalizata cu succes",
                "successMsgOnList": "Reinstalarea aplicatiei Teams a fost finalizata cu succes",
                "failureMsg": "Reinstalarea Teams nu a putut fi finalizata",
                "progressMsg": "Reinstalarea Teams este in curs de desfasurare",
                "disclaimer": "Te rugam sa retii ca aceasta va descarca si reinstala simultan aplicatia Teams. Acest lucru va reporni aplicatia Teams, te rugam sa salvezi munca ta inainte de a continua.",
                "acknowledgeQuery": "Reinstalarea aplicației Microsoft Teams ar putea rezolva problema. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "outlookOst": {
                "primaryBtn": "Da, repara Outlook",
                "secondaryBtn": "Nu repara Outlook",
                "successMsg": "Outlook a fost reparat",
                "successMsgOnList": "Outlook a fost reparat",
                "failureMsg": "Outlook nu a putut fi reparat",
                "progressMsg": "Recrearea profilului Outlook",
                "disclaimer": "Executarea acestei actiuni va recrea profilul tau Outlook local, acest lucru va initia descarcarea email-urilor din Office Exchange, te rugam sa te asiguri ca ai suficienta latime de banda si spatiu de stocare disponibile.",
                "acknowledgeQuery": "Acest lucru poate fi cauzat de probleme de conexiune sau setări învechite. Vă pot ajuta să depanați și să readuceți Outlook în sincronizare."
            },
            "repairOfficeApps": {
                "primaryBtn": "Da, repara aplicatiile Office",
                "secondaryBtn": "Nu repara aplicatiile Office",
                "successMsg": "Aplicatiile Office au fost reparate",
                "successMsgOnList": "Aplicatiile Office au fost reparate",
                "failureMsg": "Aplicatiile Office nu au putut fi reparate",
                "progressMsg": "Reinstalarea aplicatiilor Office este in curs de desfasurare",
                "disclaimer": "Executarea acestei actiuni va reinstala simultan aplicatiile Office si va incerca sa le repare, te rugam sa salvezi toata munca nesalvata inainte de a continua.",
                "acknowledgeQuery": "Acest lucru poate fi cauzat de o instalare coruptă sau o problemă de compatibilitate. Vă pot ajuta să reparați aplicațiile Office astfel încât aplicațiile să se deschidă fără probleme."
            },
            "intuneSync": {
                "primaryBtn": "Da, initiaza sincronizarea Intune",
                "secondaryBtn": "Nu initiaza sincronizarea",
                "successMsg": "Sincronizarea Intune a fost finalizata",
                "successMsgOnList": "Sincronizarea Intune a fost finalizata",
                "failureMsg": "Sincronizarea Intune nu a putut fi initiata",
                "progressMsg": "Sincronizarea Intune este in curs de desfasurare",
                "disclaimer": "Te rugam sa retii ca aceasta actiune reporneste doar serviciile de sincronizare Intune, aceasta nu reinstaleaza sau repara Intune (Portalul companiei).",
                "acknowledgeQuery": "Vă pot ajuta să actualizați starea dispozitivului și să îl sincronizați cu Intune pentru a vă asigura că este conform, actualizat și aplică cele mai recente politici."
            },
            "teamsAddin": {
                "primaryBtn": "Da, activează add-in-ul MS Teams",
                "secondaryBtn": "Nu activa add-in-ul",
                "successMsg": "Repararea add-in-ului MS Teams a fost finalizată",
                "successMsgOnList": "Repararea add-in-ului MS Teams a fost finalizată",
                "failureMsg": "Add-in-ul MS Teams nu a putut fi activat",
                "progressMsg": "Add-in-ul MS Teams este în curs de activare",
                "disclaimer": "Vă rugăm să rețineți că repararea add-in-ului MS Teams necesită repornirea Outlook. Vă rugăm să salvați toate fișierele deschise înainte de a continua.",
                "acknowledgeQuery": "Vă pot ajuta să restaurați add-in-ul Teams în Outlook, astfel încât să puteți programa din nou întâlniri. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "windowsUpdate": {
                "primaryBtn": "Da, verifică actualizările",
                "secondaryBtn": "Nu, nu verifica",
                "successMsg": "Programul pentru Windows Update a fost pornit",
                "successMsgOnList": "Programul pentru Windows Update a fost pornit",
                "failureMsg": "Nu s-a putut porni Windows Update",
                "progressMsg": "Se verifică actualizările",
                "disclaimer": "Această acțiune este concepută pentru a verifica și descărca actualizări de la Microsoft, vă rugăm să vă asigurați că sunteți conectat la o rețea adecvată pentru a descărca orice actualizări.",
                "acknowledgeQuery": "Vă pot ajuta să rezolvați problemele de actualizare Windows și conformitate pe dispozitivul dvs. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua"
            },
            "smartSolution": {
                "systemName": "Numele sistemului",
                "primaryBtn": "Rulează Healthcheck",
                "secondaryBtn": "Nu acum",
                "askToRunHealthCheck": "Ai dori ca asistenta sa efectueze o verificare rapida a starii sistemului?",
                "healthCheckApiRunning": "Se analizeaza si se efectueaza verificarea starii pe",
                "healthCheckApiFail": "Nu s-a reusit obtinerea informatiilor despre verificarea starii, te rugam sa incerci din nou",
                "healthCheckApiSuccess": "Am analizat sistemul. Urmatoarele probleme persista:",
                "systemCheckMsg": "O sistemosko kontrolo si ande progreso",
                "systemCheckMessages": {
                    "recentlyStarted": "System is up to date and recently started",
                    "appsHealthy": "All the apps installations are healthy",
                    "driveSpace": "Ample system drive free space available",
                    "noCrashes": "No application crash detected recently"
                },
                "healthCheckNoIssue": "Am analizat sistemul. <b>Totul pare sa functioneze corect.</b>",
                "recommendedActionHeading": "Actiuni recomandate",
                "askForElaboration": "Poti detalia problema specifica sau poti incarca captura de ecran a problemei cu care te confrunti.",
                "remindForSystemCheck": "Bine, ma poti anunta oricand doresti sa efectuezi o verificare a sistemului.",
                "recommendedFixesHeading": "Solutii recomandate",
                "recommendedActionInfo": "Selecteaza sau deselecteaza solutiile propuse, daca este necesar",
                "noRecommendedAction": "Nu sunt disponibile actiuni recomandate",
                "initiateActionsButton": "Incepe repararea",
                "selectedActionsProgress": "Actiunile selectate sunt in curs de procesare.",
                "selectedActionsProgressNote": "Te rugam sa folosesti asistenta in timp ce actiunea este in desfasurare. Elementul tau de actiune a fost adaugat la lista de sarcini a asistentei si poti verifica progresul, vei fi notificat odata ce actiunea a fost finalizata.",
                "selectedActionsCompleted": "Actiunile selectate au fost finalizate cu succes.",
                "selectedActionsFailed": "Actiunile selectate au esuat. Verifica cardul de sarcini al asistentei pentru detalii.",
                "selectedActionsPartiallyCompleted": "Actiunile selectate sunt partial finalizate. Verifica cardul de sarcini al asistentei pentru detalii.",
                "myActionDone": "Marcheaza ca rezolvat",
                "manualActionDisclaimer": "Procesul include atat etape automate, dar si manuale. Te rog sa urmezi actiunile specificate atunci cand vei fi rugat sa o faci!",
                "manualActionNotification": "Pentru a finaliza procesul, te rog sa realizezi manual pasii aditionali descrisi la 'Actiunile Mele'",
                "deviceSelectionHeading": "Am observat ca folosesti mai multe sisteme. Daca vrei sa rulezi urmatorul proces pe un sistem diferit, te rog sa il alegi din lista de mai jos:",
                "deviceSelectionLabel": "Alege sistemul pe care vrei sa ruleze procesul Nexthink",
                "alerts": {
                    "successTitle": "Sarcina finalizata!",
                    "successMessage": "Actiunile selectate au fost finalizate cu succes.",
                    "errorTitle": "Sarcina esuata!",
                    "errorMessage": "A aparut o eroare la procesarea actiunii tale selectate.",
                    "partialTitle": "Sarcina finalizata partial",
                    "partialMessage": "Actiunile selectate sunt partial finalizate. Verifica cardul de sarcini al asistentei pentru detalii."
                },
                "reportAndAction": {
                    "systemCrashes": {
                        "message": "Au fost <n> cazuri de ecran albastru pe dispozitivul tau in ultimele 7 zile",
                        "action": "Te rugam sa contactezi GSD pentru ajutor suplimentar",
                        "actionInfo": "(Fara actiune) te rugam sa contactezi GSD pentru asistenta suplimentara"
                    },
                    "edgeCrashes": {
                        "message": "Am gasit <n> crash-uri Edge in ultimele 7 zile",
                        "action": "Curata cache-ul browser-ului Edge",
                        "actionInfo": "Aceasta va curata cache-urile browser-ului Edge si nu va modifica fisierele personale."
                    },
                    "chromeCrashes": {
                        "message": "Am gasit <n> crash-uri Chrome in ultimele 7 zile",
                        "action": "Curata cache-ul browser-ului Chrome",
                        "actionInfo": "Aceasta va curata cache-ul Chrome, fara a modifica fisierele existente."
                    },
                    "ZScalarStatus": {
                        "message": "Am gasit ca serviciul Zscaler s-a oprit pe dispozitivul tau",
                        "action": "Reporneste serviciul Zscaler",
                        "actionInfo": "Aceasta actiune va reporni conexiunea de retea. Nu va avea niciun impact asupra programelor tale deschise."
                    },
                    "ZScalarState": {
                        "message": "Am gasit ca serviciul Zscaler s-a oprit pe dispozitivul tau",
                        "action": "Reseteaza Zscaler",
                        "actionInfo": "Aceasta actiune va reporni conexiunea de retea. Nu va avea niciun impact asupra programelor tale deschise."
                    },
                    "driveFreeSpace": {
                        "message": "Dispozitivul tau are doar <n> GB de spatiu liber.",
                        "action": "Efectueaza curatarea discului",
                        "actionInfo": "Numai fisierele tale temporare si cosul de reciclare al dispozitivului tau sunt curatate in aceasta actiune."
                    },
                    "daysSinceFullBoot": {
                        "message": "Dispozitivul tau nu a fost repornit in ultimele <n> zile.",
                        "action": "Reporneste dispozitivul cat mai curand posibil.",
                        "actionInfo": ""
                    },
                    "teamsCrashes": {
                        "message": "Dispozitivele tale au avut <n> crash-uri MS Teams in ultimele 7 zile",
                        "action": "Efectueaza curatarea cache-ului Teams",
                        "actionInfo": "Aceasta actiune va curata cache-ul MS Teams si il va reporni. De asemenea, poate sterge mesajele MS Teams nefinalizate / nesent."
                    },
                    "teamsPluginDisabled": {
                        "message": "Add-in-ul MS Teams este dezactivat pentru Outlook-ul tau.",
                        "action": "Seteaza plugin-urile Outlook",
                        "actionInfo": "Aceasta actiune activeaza plugin-ul Teams in Outlook-ul tau si reporneste aplicatia."
                    },
                    "outlookOstStatus": {
                        "message": "Profilul tau Outlook a depasit dimensiunea optima",
                        "action": "Repara fisierul OST Outlook",
                        "actionInfo": "Aceasta redenumeste fisierul OST Outlook si reporneste aplicatia. Va sterge orice email-uri in schita."
                    },
                    "lastOsUpdate": {
                        "message": "Sistemul tau de operare Windows-ul tau a fost actualizat ultima data acum <n> zile",
                        "action": "Reporneste dispozitivul cat mai curand posibil",
                        "actionInfo": ""
                    }
                },
                "acknowledgeQuery": "Vă pot ajuta să depanați problema cu dispozitivul dvs. Să verificăm și să rezolvăm problema"
            },
            "declineScriptMsg": "Nu vreau să rulez scriptul Nexthink, ajută-mă cu o altă soluție",
            "timezone": {
                "primaryBtn": "Da, continuă",
                "secondaryBtn": "Nu, nu actualiza",
                "successMsg": "Detectarea fusului orar a fost setată pe automat",
                "successMsgOnList": "Detectarea fusului orar a fost setată pe automat",
                "failureMsg": "Configurarea fusului orar nu a putut fi actualizată",
                "progressMsg": "Se actualizează setările fusului orar",
                "disclaimer": "Vă rugăm să rețineți că această acțiune este concepută pentru a seta serviciul de fus orar pe automat, permițând Windows să actualizeze ceasul desktopului în funcție de locația detectată.",
                "acknowledgeQuery": "Vă pot ajuta să corectați ora sistemului și setările de fus orar. Majoritatea problemelor legate de timp, precum derapajul ceasului, marcaje de timp incorecte, coduri de autentificare eșuate sau ore de întâlnire incorecte, sunt cauzate de un fus orar incorect sau de setări de sincronizare automată dezactivate. Vă rugăm să faceți clic pe butonul de mai jos pentru a detecta și remedia automat configurația Windows pentru ora și fusul orar."
            },
            "chooseBrowser": "Alegeți browserul pentru acțiunea de curățare a cache-ului",
            "outlookAutoComplete": {
                "primaryBtn": "Da, șterge memoria cache Outlook",
                "secondaryBtn": "Nu, nu șterge memoria cache Outlook",
                "successMsg": "Memoria cache de completare automată Outlook a fost ștearsă",
                "successMsgOnList": "Memoria cache de completare automată Outlook a fost ștearsă",
                "failureMsg": "Memoria cache de completare automată Outlook nu a putut fi ștearsă",
                "progressMsg": "Se șterge memoria cache de completare automată Outlook",
                "disclaimer": "Vă rugăm să rețineți că ștergerea memoriei cache de completare automată Outlook va elimina sugestiile de adrese de e-mail salvate. Această acțiune nu poate fi anulată.",
                "acknowledgeQuery": "Vă pot ajuta să remediați memoria cache pentru completarea automată din Outlook. Vă rugăm să faceți clic pe butonul de mai jos pentru a remedia automat completarea automată din Outlook."
            },
            "restartZscalar": {
                "primaryBtn": "Da, continuă",
                "secondaryBtn": "Nu, nu reporni Zscaler",
                "successMsg": "Zscaler a fost repornit",
                "successMsgOnList": "Zscaler a fost repornit",
                "failureMsg": "Zscaler nu a putut fi repornit",
                "progressMsg": "Se repornesc serviciile Zscaler",
                "disclaimer": "Vă rugăm să rețineți că repornirea Zscaler poate deconecta temporar internetul și aplicațiile de lucru. De obicei, acest proces durează mai puțin de un minut.",
                "acknowledgeQuery": "Vă pot ajuta să remediați problema serviciilor Zscaler. Vă rugăm să faceți clic pe butonul de mai jos pentru a remedia problemele Zscaler."
            },
            "onedrive": {
                "primaryBtn": "Da, repară OneDrive",
                "secondaryBtn": "Nu, nu rula repararea OneDrive",
                "successMsg": "Repararea OneDrive a fost finalizată",
                "successMsgOnList": "Repararea OneDrive a fost finalizată",
                "failureMsg": "Acțiunea de reparare OneDrive nu a putut fi finalizată cu succes",
                "progressMsg": "Se rulează repararea OneDrive",
                "disclaimer": "Vă rugăm să rețineți că repararea OneDrive va determina sincronizarea fișierelor locale în cloud și poate întrerupe sincronizările personalizate pentru Onedrive",
                "acknowledgeQuery": "Vă pot ajuta să remediați problemele OneDrive. Vă rugăm să faceți clic pe butonul de mai jos pentru a remedia problemele OneDrive."
            },
            "smartcard": {
                "primaryBtn": "Da, elimină Smart card",
                "secondaryBtn": "Nu, nu elimina Smartcard",
                "successMsg": "Microsoft Smartcard a fost eliminat",
                "successMsgOnList": "Microsoft Smartcard a fost eliminat",
                "failureMsg": "Nu se poate elimina Microsoft Smartcard",
                "progressMsg": "Se elimină Microsoft Smartcard",
                "disclaimer": "Executarea acestei acțiuni poate dura până la 1 minut.",
                "acknowledgeQuery": "Vă pot ajuta să remediați problemele Microsoft Smart Card Reader. Vă rugăm să faceți clic pe butonul de mai jos pentru a remedia problemele Smart Card."
            },
            "errorFetchingReport": "Îmi pare rău, nu am putut prelua raportul. Vă rog să încercați din nou mai târziu.",
            "automatedFix": "Remediere automată",
            "automatedFixConsent": "Pot rezolva această problemă pe dispozitivul dvs. Doriți să inițiez remedierea automată?",
            "primaryButton": "Da, inițiază remedierea",
            "teamViewerReset": {
                "primaryBtn": "Da, continuați mai departe",
                "secondaryBtn": "Nu, nu resetați",
                "successMsg": "Serviciile Teamviewer au fost resetate",
                "successMsgOnList": "Serviciile Teamviewer au fost resetate",
                "failureMsg": "Nu s-a putut reseta serviciile Teamviewer",
                "progressMsg": "Serviciile Teamviewer sunt în curs de repornire",
                "disclaimer": "Această acțiune va reseta serviciile dvs. teamviewer și va reporni aplicația dvs. teamviewer, vă rugăm să vă asigurați că v-ați salvat munca înainte de a continua",
                "acknowledgeQuery": "Vă pot ajuta să resetați Teamviewer. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "zoomUninstall": {
                "primaryBtn": "Da, dezinstalează Zoom",
                "secondaryBtn": "Nu, nu dezinstala",
                "successMsg": "Zoom a fost dezinstalat",
                "successMsgOnList": "Zoom a fost dezinstalat",
                "failureMsg": "Nu s-a putut elimina Zoom",
                "progressMsg": "Dezinstalarea Zoom este în curs",
                "disclaimer": "Această acțiune va dezinstala Zoom de pe dispozitivul dvs.; de asemenea, va șterge toate configurațiile pentru Zoom.",
                "acknowledgeQuery": "Vă pot ajuta să dezinstalați Zoom. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "webexUninstall": {
                "primaryBtn": "Da, dezinstalează Webex",
                "secondaryBtn": "Nu, nu dezinstala",
                "successMsg": "Webex a fost dezinstalat",
                "successMsgOnList": "Webex a fost dezinstalat",
                "failureMsg": "Nu s-a putut elimina Webex",
                "progressMsg": "Dezinstalarea Webex este în curs",
                "disclaimer": "Această acțiune va dezinstala Cisco Webex de pe dispozitivul dvs.; de asemenea, va șterge toate configurațiile pentru Cisco Webex.",
                "acknowledgeQuery": "Vă pot ajuta să dezinstalați Cisco Webex. Vă rugăm să faceți clic pe butonul de mai jos pentru a continua."
            },
            "recommendedAction": "Acțiune recomandată",
            "noKbArticleFound": "Nu au fost găsite instrucțiuni manuale sau articole de cunoștințe pentru această problemă. Totuși, există o acțiune recomandată care ar putea să o rezolve:"
        },
        "sessions": {
            "title": "Convorbiri recente",
            "clearAll": "Sterge tot",
            "deleteMessage": "ștergeți sesiunea",
            "footer": "Nota: Conversatiile din ultimele 30 de zile vor fi stocate.",
            "recentChatTitle": "Istoric conversatii (30 de zile)",
            "noRecentChat": "Nu exista conversatii recente",
            "startNewChat": "Incepe o conversatie noua",
            "learnMore": "Afla mai multe.",
            "learnMoreTooltip": "Conform politicii de retentie MyHelp, conversatiile tale recente vor fi disponibile timp de 30 de zile, cu exceptia cazului in care le stergi folosind butoanele de stergere sau stergere tot."
        },
        "cancelBtn": "Anulează apelul",
        "feedbackMsg": "Vă mulțumim pentru Feedback! Apreciem ajutorul dumneavoastră în îmbunătățirea serviciilor noastre.",
        "incError": "Vă rugăm să introduceți detalii valide ale incidentului",
        "contactError": "Vă rugăm să introduceți un număr de contact valid",
        "searchAsk": "Descrie problema ta, de exemplu: resetarea parolei",
        "teamsInsights": {
            "specifyDateTime": "Ne puteți specifica data și ora la care s-a întâmplat acest lucru, precum și întâlnirea sau chatul implicat?",
            "date": "Dată",
            "getMeetings": "Preia întâlniri",
            "cancel": "Anulează",
            "noMeetings": "Nu au fost găsite întâlniri pentru data selectată.",
            "meetingInstruction": "Vă rugăm să selectați întâlnirea/apelul specific afectat de problemele de calitate.",
            "identifyIssue": "Identifică problema",
            "issueDetectionCompleted": "Detectarea problemei a fost finalizată.",
            "detectingIssues": "Se detectează problemele întâlnirii",
            "recommendedActions": "Acțiuni recomandate:",
            "noInsightsFound": "Nu au fost găsite informații pentru apelul selectat.",
            "meetingList": "Lista întâlnirilor/apelurilor",
            "fetchingMeetings": "Se preiau toate întâlnirile Teams din ziua respectivă",
            "windowsOnly": "Informațiile despre întâlniri sunt disponibile doar pentru apelurile la care s-a participat de pe dispozitive Windows.",
            "confirmCreateIncident": "Doriți să creați un tichet de incident pentru problema detectată în întâlnire?",
            "getMeetingsCancelMsg": "Cererea de preluare a întâlnirilor a fost anulată.",
            "identifyIssueCancelMsg": "Cererea de identificare a problemei a fost anulată.",
            "createIncidentCancelMsg": "Cererea de creare a incidentului a fost anulată.",
            "noIssueFoundInstruction": "Am verificat mai mulți indicatori de performanță de partea dumneavoastră și totul pare în regulă. Dacă ați întâmpinat probleme în timpul apelului/întâlnirii, cauza principală este, prin urmare, foarte probabil de partea celorlalți participanți.",
            "report": {
                "lowWifiRootCause": "Semnalul dvs. WiFi a fost slab în timpul apelului și acest lucru poate să fi cauzat probleme de calitate. Vă rugăm să verificați distanța față de router dacă ați fost conectat dintr-o rețea de acasă/la distanță.",
                "networkIssueRootCauseManaged": "Se pare că erați conectat dintr-un birou E.ON și ați întâmpinat probleme de rețea care afectează calitatea întâlnirii. Vă rugăm să luați în considerare deschiderea unui tichet de incident pentru a-l raporta și menționați locația în care ați fost în tichet.",
                "networkIssueRootCauseUnmanaged": "Se pare că nu erați conectat dintr-un birou E.ON și este posibil să fi întâmpinat probleme de rețea care au afectat calitatea întâlnirii. Vă rugăm să verificați stabilitatea conexiunii WiFi sau la Internet locale. Dacă este posibil, utilizați o conexiune prin cablu sau apropiați-vă de routerul WiFi pentru a îmbunătăți performanța rețelei.",
                "noDataRootCause": "Nu au fost disponibile informații pentru acest parametru în timpul apelului.",
                "noIssueRootCause": "Nu a fost detectată nicio problemă pentru acest parametru.",
                "noIssueRecommendation": "Nu este necesară nicio acțiune.",
                "failed": "Eșuat",
                "checking": "Verificare",
                "okay": "OK",
                "na": "N/A",
                "audio": "Audio",
                "video": "Video",
                "deviceCpuUsage": {
                    "displayName": "Utilizare CPU dispozitiv",
                    "rootCause": "Am detectat o încărcare ridicată a CPU în timpul apelului pe dispozitivul dvs. Vă rugăm să verificați dacă ați avut procese în fundal sau aplicații deschise și care rulau în timpul apelului și evitați să aveți prea multe aplicații deschise, pentru ca performanța hardware a dispozitivului să poată fi alocată întâlnirii.",
                    "recommendation": "Închideți aplicațiile de fundal inutile în timpul apelurilor pentru a reduce încărcarea CPU."
                },
                "deviceMemoryUsedPct": {
                    "displayName": "Utilizare memorie dispozitiv",
                    "rootCause": "Am detectat o utilizare ridicată a memoriei în timpul apelului pe dispozitivul dvs. Vă rugăm să verificați dacă ați avut procese în fundal sau aplicații deschise și care rulau în timpul apelului și evitați să aveți prea multe aplicații deschise, pentru ca performanța hardware a dispozitivului să poată fi alocată întâlnirii.",
                    "recommendation": "Închideți aplicațiile de fundal inutile în timpul apelurilor pentru a reduce utilizarea memoriei."
                },
                "wifiSignalQuality": {
                    "displayName": "Calitatea semnalului WiFi",
                    "recommendation": "Apropiați-vă de router sau treceți la o sursă de semnal WiFi mai puternică."
                },
                "audioJitter": {
                    "displayName": "Jitter audio"
                },
                "audioJBDelay": {
                    "displayName": "Întârziere buffer jitter audio"
                },
                "audioRecvLossRate": {
                    "displayName": "Rată de pierdere la recepția audio"
                },
                "audioRtt": {
                    "displayName": "Timp dus-întors audio"
                },
                "videoRtt": {
                    "displayName": "Timp dus-întors video"
                },
                "videoRecvLossRate": {
                    "displayName": "Rată de pierdere la recepția video"
                },
                "wifiChannelCenterFrequencyInKilohertz": {
                    "displayName": "Frecvența centrală a canalului WiFi (kHz)",
                    "rootCause": "Utilizați o conexiune WiFi de 2,4 GHz, care cauzează frecvent probleme de calitate a apelului. Vă rugăm să luați în considerare trecerea la o bandă WiFi de 5 GHz sau mai mare.",
                    "recommendation": "Treceți la o bandă WiFi de 5 GHz (sau mai mare) pentru a îmbunătăți calitatea apelului."
                },
                "wifiSsidChangeDetected": {
                    "displayName": "Schimbare de rețea detectată",
                    "rootCauseManaged": "Am identificat schimbări de WiFi sau punct de acces în timpul apelului dvs. într-un birou E.ON. Acest lucru ar fi putut cauza o întrerupere a apelului. Dacă nu v-ați deplasat cu dispozitivul dvs., vă rugăm să înregistrați acest lucru ca tichet de incident.",
                    "rootCauseUnmanaged": "Am identificat că nu erați conectat dintr-o locație E.ON. Vă rugăm să verificați dacă conexiunea dvs. WiFi este stabilă, deoarece problemele de rețea pot afecta calitatea întâlnirii."
                }
            }
        },
        "rightSidebar": {
            "panelLabel": "Activități în desfășurare",
            "closePanel": "Închide panoul de activități",
            "openPanel": "Deschide panoul de activități",
            "emptyState": "Nicio activitate în desfășurare momentan.",
            "ticketPrefix": "Tichet",
            "openedAtPrefix": "Deschis:",
            "showTicketDetails": "Vezi rezumatul tichetului",
            "defaultTaskLabel": "Acțiune Nexthink"
        }
    },
    "snow": {
        "welcomeNote": "Te rugam sa gasesti mai jos un rezumat al incidentelor tale deschise, cererilor tale si resurselor IT.",
        "tabName": {
            "incidents": "Incidente",
            "orders": "Comenzi",
            "itResources": "Resurse IT",
            "incidentsTable": {
                "noData": "Date indisponibile",
                "btnText": "Deschide un nou incident",
                "ongoing": "In desfasurare",
                "closed": "Inchis",
                "headlineText": "Incidente"
            },
            "orderTable": {
                "number": "Numar",
                "catItem": "Item Cat",
                "approvalSet": "Set Aprobare",
                "state": "Stare",
                "dueDate": "Data Limită",
                "createdOn": "Creat Pe",
                "noData": "Date indisponibile",
                "btnText": "Serviciiclegate de comezi IT",
                "headlineText": "Comenzi",
                "tooltipText": "Solicită și gestionează echipamente IT, software, licențe sau servicii"
            },
            "itResourcesTable": {
                "modelCategory": "Categorie Model",
                "model": "Model",
                "computerName": "Nume Computer",
                "serialNumber": "Numar Serial",
                "serviceValue1": "Valoare Serviciu1",
                "serviceValue2": "Valoare Serviciu2",
                "noData": "Date indisponibile",
                "btnText": "Deschide un tichet pentru resurse IT",
                "headlineText": "Activele Mele"
            }
        }
    },
    "moveTabAndTiles": {
        "tabNames": "Tab",
        "favourite": "Preferat",
        "categorizeTiles": "Tabloul personalizat",
        "enterTabName": "Introduceti numele tab-ului",
        "tabNameError": "Va rugam sa introduceti un nume de tab unic, cu un minim de 2 si un maxim de 20 de caractere!",
        "tabInputLabel": "Numele tab-ului",
        "addTabButton": "Adauga tab",
        "personalizeTab": "Personalizeaza tab-urile",
        "personalizeTiles": "Personalizeaza placile",
        "addTab": "Adauga tab nou",
        "removeTabConfrim": "Sunteti sigur ca doriti sa eliminati tab-ul",
        "with": " cu",
        "cardIn": "spatii de lucru in?",
        "actionUndone": "Aceasta actiune nu poate fi anulata.",
        "categorizeTilesTitle": "Renuntati la denumirea tab-urilor, eliminati tab-urile si mutati placile in interiorul tab-urilor",
        "addTabTitle": "Adauga tab nou. Puteti crea maximum 4 tab-uri.",
        "organiseTilesTitle": "Pentru a muta pozitia spatiilor de lucru"
    },
    "dataTable": {
        "pagingData": "Itemi pe pagina",
        "itemString": "Itemi",
        "ofString": " din "
    },
    "tourData": {
        "userActions": {
            "back": "Inapoi",
            "close": "Inchide",
            "last": "Finalizare",
            "next": "Urmatorul",
            "step": "Pas",
            "of": "din",
            "open": "Deschide dialogul",
            "skip": "Sari",
            "start_tour": "Incepe turul",
            "tour_info": "Doriti sa va aratam functionalitatile de baza intr-un tur ghidat rapid? Ar trebui sa dureze doar 1-2 minute..."
        },
        "tile": {
            "step1": "Folositi MyHelp pentru a gasi aplicatiile de lucru tipice sau pentru a pune orice intrebare legata de resursele E.ON, de exemplu IT, proiectele dumneavoastra, cursurile de formare, politicile companiei si multe altele.",
            "step2": "Puteti afla mai multe despre MyHelp si functiile sale, puteti gasi raspunsuri la intrebarile frecvente si puteti invata sfaturi si trucuri utile in documentatia pentru utilizatori.",
            "step3": "Inca puteti schimba limba preferata oricand de aici.",
            "step4": "Puteti iesi din cont facand clic aici.",
            "step5": "Începe o conversație nouă, accesează chat-urile recente pentru a continua de unde ai rămas sau începe o căutare E.ON apăsând pe lupă",
            "step6": "Panoul de control personalizat va permite sa organizati si sa accesati aplicatiile de lucru preferate. Cautati o aplicatie si adaugati-o cu simbolul plus. Creati noi tab-uri si reorganizati aplicatiile dupa cum este necesar."
        },
        "tab": {
            "step1": "Puteti adauga un tab nou facand clic aici.",
            "step2": "Faceti clic aici pentru a organiza secventa placilor.",
            "step3": "Aici puteti redenumi si organiza tab-urile."
        },
        "chat": {
            "step1": "Descrie-ți problema IT",
            "step1_description": "Primește asistență pas cu pas pentru probleme IT frecvente – pe baza bazelor de cunoștințe ale asistenței IT E.ON.La nevoie, MyHelp te direcționează și către canalul potrivit de asistență IT.",
            "step5": "Descoperă solicitări IT tipice",
            "step5_description": "Aceste exemple prezintă solicitări IT frecvente în care MyHelp te poate sprijini pas cu pas.",
            "navigation": "Navighează în MyHelp",
            "headerNavigation_description": "Folosește navigarea din antet pentru a deschide Ask MyHelp, Dashboard și alte pagini disponibile.",
            "sidebarNavigation_description": "Folosește meniul lateral pentru a deschide pagini, a începe un chat nou sau a reveni la conversațiile recente.",
            "support_description": "Deschide My IT-Support pentru ajutor cu problema ta IT și pentru a găsi opțiunea potrivită de asistență.",
            "step3": "Accesează mai rapid aplicațiile tale",
            "step3_description": "Folosește tabloul de bord pentru a salva aplicațiile utilizate frecvent și pentru a-ți crea spațiul de lucru personal.",
            "step4": "Pornește un chat nou sau reia conversațiile anterioare",
            "step4_description": "Folosește bara laterală pentru a începe o conversație nouă sau pentru a reveni rapid la chaturile anterioare.",
            "step2": "Explorați subiecte IT comune",
            "step2_description": "Aceste exemple prezintă subiecte și solicitări IT comune pe care MyHelp vă poate ajuta să le rezolvați pas cu pas."
        }
    },
    "allApps": {
        "addAppsBtn": "Adauga aplicatii",
        "addAppsInfo": "Faceți clic pe Adăugați aplicații pentru a începe",
        "addAppsTitle": "Creează-ți propriul spațiu de lucru personalizat",
        "addAppsDesc": "Adăugați aplicațiile pe care le utilizați cel mai des pentru un acces mai rapid la instrumentele pe care le folosiți zilnic",
        "customTileButton": "Adăugați un card personalizat",
        "CustomTileHeading": "Card personalizat",
        "customTileTitleLabel": "Titlul cardului",
        "customTileSubTitle": "Descrierea cardului",
        "customTileUrlLabel": "Legătură card",
        "createCardBtn": "Creează card",
        "modalHeading": "Aplicatii pe E.ON",
        "modalDesc": "Cautati sau selectati o aplicatie pentru a o adauga pe pagina de start",
        "titleRequired": "Titlul cardului este obligatoriu",
        "linkRequired": "Legătura cardului este obligatorie",
        "searchPlaceholder": "Cautati aplicatia"
    },
    "onboardingPortal": {
        "onboardAppBtn": "Portal de onboarding",
        "heading": "Portal de integrare",
        "subHeading": "Revizuiți aplicația dvs., adăugați altele noi și partajați accesul de gestionare cu echipa dvs.",
        "modules": {
            "home": "Acasă",
            "apps": "Aplicații",
            "appsLabel": "Aplicații",
            "qna": "Q&A",
            "qnaLabel": "Întrebare și răspuns",
            "review": "Revizuire",
            "reviewLabel": "Revizuire",
            "onboardApp": "Adaugă aplicație nouă",
            "manageApp": "Gestionează aplicații",
            "defaultApps": "Aplicații implicite",
            "onboardQnA": "Adaugă QnA",
            "manageQnA": "Gestionează QnA",
            "reviewDashboard": "Tablou de bord reviewer",
            "reviewApps": "Revizuiește aplicații",
            "reviewQnA": "Revizuiește Q&A"
        },
        "appOnboardingForm": {
            "formHeading": "Adaugă aplicație nouă",
            "successAlert": "Aplicația a fost adăugată cu succes!",
            "appTitleLabel": "Titlul aplicației",
            "appTitleTooltip": "Numele aplicației de afișat",
            "appTitlePlaceholder": "Numele aplicației de afișat",
            "appTitleError": "Titlul aplicației este obligatoriu",
            "appSubTitleLabel": "Subtitlul aplicației",
            "appSubTitleTooltip": "Subtitlul aplicației",
            "appSubTitlePlaceholder": "Subtitlul aplicației",
            "appSubTitleError": "Subtitlul aplicației este obligatoriu",
            "appUrlLabel": "URL aplicație",
            "appUrlTooltip": "URL-ul țintă al aplicației",
            "appUrlPlaceholder": "URL-ul țintă al aplicației",
            "appUrlError": "URL-ul aplicației este obligatoriu",
            "appKeywordsLabel": "synKeywords (separate prin virgulă)",
            "appKeywordsTooltip": "Completați sinonimele pe care utilizatorii le-ar putea folosi pentru a găsi aplicația și separați-le prin virgulă",
            "appKeywordsPlaceholder": "Completați sinonimele pe care utilizatorii le-ar putea folosi pentru a găsi aplicația și separați-le prin virgulă",
            "appKeywordsError": "Cuvintele cheie sunt obligatorii",
            "appCompaniesAllowedLabel": "Companii permise",
            "appCompaniesAllowedTooltip": "Lista tuturor companiilor unde această aplicație este permisă. Dacă este permisă pentru toate, lăsați necompletat.",
            "appCompaniesAllowedInfoMessage": "Lista tuturor companiilor unde această aplicație este permisă. Dacă este permisă pentru toate, lăsați necompletat.",
            "appCompaniesAllowedOtherLabel": "Alte companii permise",
            "appCompaniesAllowedOtherPlaceholder": "Specificați alte companii permise",
            "appCompaniesRestrictedLabel": "Companii restricționate",
            "appCompaniesRestrictedTooltip": "Lista tuturor companiilor unde această aplicație NU este permisă. Dacă nu există restricții, lăsați necompletat.",
            "appCompaniesRestrictedInfoMessage": "Lista tuturor companiilor unde această aplicație NU este permisă. Dacă nu există restricții, lăsați necompletat.",
            "appCompaniesRestrictedOtherLabel": "Alte companii restricționate",
            "appCompaniesRestrictedOtherPlaceholder": "Specificați alte companii restricționate",
            "appTooltipLabel": "Tooltip (menționați toate limbile, dacă se afișează nume diferite)",
            "appTooltipTooltip": "Menționați toate limbile, dacă se afișează nume diferite, ex. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipPlaceholder": "Menționați toate limbile, dacă se afișează nume diferite, ex. EN- This is My HR tooltip, DE- Dies ist mein HR-Tooltip",
            "appTooltipError": "Tooltip-ul este obligatoriu",
            "appIconLabel": "Încărcați pictograma aplicației",
            "appIconTooltip": "Încărcați pictograma aplicației",
            "previewAppBtn": "Previzualizare aplicație",
            "cancelBtn": "Anulați",
            "closeBtn": "Închideți",
            "submitAppBtn": "Trimiteți aplicația",
            "updateAppBtn": "Actualizați aplicația",
            "editAppBtn": "Editați aplicația",
            "appTitlePreview": "Titlu",
            "appSubTitlePreview": "Subtitlu",
            "appUrlPreview": "URL",
            "appKeywordsPreview": "Cuvinte cheie",
            "appCompaniesAllowedPreview": "Companii permise",
            "appCompaniesRestrictedPreview": "Companii restricționate",
            "appTooltipPreview": "Tooltip",
            "message": "Odată ce o aplicație este trimisă, intră în starea În așteptare și parcurge un ciclu de viață de revizuire definit — progresând de la În așteptare → Aprobat (în curs de revizuire/testare) → În QA (aprobat formal și în curs de verificare) → În producție (live și vizibil pentru utilizatorii finali pe MyHelp), sau poate fi Respins dacă nu îndeplinește criteriile; în acest caz, persoana interesată poate edita și retrimite."
        },
        "qnaOnboardingForm": {
            "formHeading": "Adaugă QnA nou",
            "successAlert": "QnA a fost adăugat cu succes!",
            "qnaQuestionLabel": "Întrebare",
            "qnaQuestionTooltip": "Introduceți întrebarea pentru elementul QnA",
            "qnaQuestionPlaceholder": "Introduceți întrebarea",
            "qnaQuestionError": "Întrebarea este obligatorie",
            "qnaAnswerLabel": "Răspuns",
            "qnaAnswerTooltip": "Introduceți răspunsul pentru elementul QnA",
            "qnaAnswerPlaceholder": "Introduceți răspunsul la întrebare",
            "qnaAnswerError": "Răspunsul este obligatoriu",
            "qnaCategoryLabel": "Categorie",
            "qnaCategoryTooltip": "Selectează categoria pentru elementul QnA",
            "qnaCategoryPlaceholder": "Selectează categoria pentru elementul QnA",
            "qnaCategoryError": "Categoria este obligatorie",
            "qnaCategoryOtherLabel": "Altă categorie",
            "qnaCategoryOtherPlaceholder": "Introdu categorie personalizată",
            "qnaCompaniesAllowedLabel": "Companii permise",
            "qnaCompaniesAllowedTooltip": "Lista tuturor companiilor unde această aplicație este permisă. Dacă este permisă pentru toate, lăsați necompletat.",
            "qnaCompaniesAllowedInfoMessage": "Lista tuturor companiilor unde această aplicație este permisă. Dacă este permisă pentru toate, lăsați necompletat.",
            "qnaCompaniesAllowedOtherLabel": "Alte companii permise",
            "qnaCompaniesAllowedOtherPlaceholder": "Specificați alte companii permise",
            "qnaCompaniesRestrictedLabel": "Companii restricționate",
            "qnaCompaniesRestrictedTooltip": "Lista tuturor companiilor unde această aplicație NU este permisă. Dacă nu există restricții, lăsați necompletat.",
            "qnaCompaniesRestrictedInfoMessage": "Lista tuturor companiilor unde această aplicație NU este permisă. Dacă nu există restricții, lăsați necompletat.",
            "qnaCompaniesRestrictedOtherLabel": "Alte companii restricționate",
            "qnaCompaniesRestrictedOtherPlaceholder": "Specificați alte companii restricționate",
            "previewQnABtn": "Previzualizare QnA",
            "cancelBtn": "Anulați",
            "submitQnABtn": "Trimiteți QnA",
            "updateQnABtn": "Actualizați QnA",
            "editQnABtn": "Editați QnA",
            "addNewQnABtn": "+ Adăugați QnA",
            "qnaQuestionPreview": "Întrebare",
            "qnaAnswerPreview": "Răspuns",
            "qnaCompaniesAllowedPreview": "Companii permise",
            "qnaCompaniesRestrictedPreview": "Companii restricționate",
            "message": "Odată ce o înregistrare Q&A este trimisă, intră în starea În așteptare și parcurge un ciclu de viață de revizuire definit — progresând de la În așteptare → Aprobat (în curs de revizuire/testare) → În QA (aprobat formal și în curs de verificare) → În producție (live și vizibil pentru utilizatorii finali pe MyHelp), sau poate fi Respins dacă nu îndeplinește criteriile; în acest caz, persoana interesată poate edita și retrimite."
        },
        "manageBtn": "Gestionați",
        "refreshBtn": "Reîmprospătare",
        "exportBtn": "Exportați",
        "exportCsvBtn": "CSV",
        "exportExcelBtn": "Excel",
        "exportAppsCsvBtn": "Exportați aplicațiile ca CSV",
        "exportAppsExcelBtn": "Exportați aplicațiile ca Excel",
        "exportQnACsvBtn": "Exportați QnA ca CSV",
        "exportQnAExcelBtn": "Exportați QnA ca Excel",
        "approveBtn": "Aproba",
        "rejectBtn": "Nu aproba",
        "toQABtn": "Mută în QA",
        "toProdBtn": "Mută în producție",
        "editBtn": "Editează",
        "viewBtn": "Vizualizează",
        "closeBtn": "Închideți",
        "dashboard": {
            "appsTitle": "Aplicații accesibile",
            "appsText": "Aplicații disponibile pentru tine prin proprietate sau partajare în echipă.",
            "qnaTitle": "Întrebări și răspunsuri",
            "qnaText": "Întrebări și răspunsuri disponibile pentru tine prin proprietate sau partajare în echipă."
        },
        "modalLabel": {
            "reviewAppTitle": "Revizuiți aplicația pentru integrare",
            "reviewQnATitle": "Revizuiți Q&A pentru integrare",
            "owner": "Proprietar",
            "createdOn": "Creat la",
            "status": "Stare",
            "url": "URL",
            "tooltip": "Tooltip",
            "companiesAllowed": "Companii permise",
            "companiesRestricted": "Companii restricționate",
            "keywords": "Cuvinte cheie",
            "reviewerComments": "Comentarii de revizuire",
            "category": "Categorie",
            "question": "Întrebare",
            "answer": "Răspuns",
            "mail": "E-mail"
        },
        "statusLabel": {
            "pending": "În așteptare",
            "approved": "Aprobat",
            "rejected": "Respins",
            "onhold": "În suspensie",
            "unknown": "Necunoscut",
            "all": "Toate",
            "inQA": "În QA",
            "inProd": "În producție"
        },
        "activityLabel": {
            "allowed": "Permis",
            "restricted": "Restricționat"
        },
        "tableHeaders": {
            "status": "Status",
            "action": "Acțiune",
            "icon": "Iconiță",
            "title": "Titlu",
            "subTitle": "Subtitlu",
            "question": "Întrebare",
            "answer": "Răspuns",
            "category": "Categorie",
            "owner": "Proprietar",
            "description": "Descriere",
            "apps": "Aplicații",
            "qna": "Întrebare și răspuns",
            "defaultApps": "Aplicații implicite",
            "defaultAppsActivity": "Modificări ale aplicațiilor implicite",
            "search": "Căutare",
            "selectCompany": "Selectează companie",
            "otherCompany": "Numele altei companii",
            "selectAll": "Selectează tot",
            "company": "Companie",
            "update": "Actualizează",
            "comments": "Comentarii"
        },
        "noData": {
            "dashboardEmpty": "Nu au fost adăugate aplicații sau Q&A",
            "dashboardAppsEmpty": "Nu au fost adăugate aplicații",
            "dashboardQnAEmpty": "Nu au fost adăugate Q&A",
            "reviewDashboardEmpty": "Nu au fost trimise aplicații sau Q&A pentru revizuire.",
            "reviewAppsEmpty": "Nu au fost trimise aplicații pentru revizuire.",
            "reviewQnAEmpty": "Nu au fost trimise Q&A pentru revizuire."
        },
        "manageApp": {
            "heading": "Gestionați aplicațiile",
            "subHeading": "Sunt afișate doar aplicațiile pe care le dețineți sau la care vi s-a acordat acces."
        },
        "manageQnA": {
            "heading": "Gestionați QnA",
            "subHeading": "Sunt afișate doar QnA-urile pe care le dețineți sau la care vi s-a acordat acces."
        },
        "defaultApps": {
            "heading": "Aplicații implicite",
            "subHeading": "Acestea sunt aplicațiile implicite disponibile pentru toți utilizatorii. Puteți solicita încărcarea de noi aplicații sau puteți solicita acces pentru a gestiona aplicațiile existente din secțiunea Gestionați aplicațiile.",
            "searchPlaceholder": "Căutați aplicații"
        },
        "reviewDashboard": {
            "heading": "Tablou de bord revizuire",
            "subHeading": "Revizuiește cererile de onboarding pentru aplicații aflate în așteptare și aprobă-le sau respinge-le. Revizuirile tale la timp ne ajută să menținem o colecție de aplicații relevantă și utilă pentru toți."
        },
        "reviewApps": {
            "heading": "Revizuire aplicații",
            "subHeading": "Revizuiește cererile de onboarding pentru aplicații aflate în așteptare și aprobă-le sau respinge-le. Revizuirile tale la timp ne ajută să menținem o colecție de aplicații relevantă și utilă pentru toți."
        },
        "reviewQnA": {
            "heading": "Revizuire Q&A",
            "subHeading": "Revizuiește cererile de onboarding QnA aflate în așteptare și aprobă-le sau respinge-le. Revizuirile tale la timp ne ajută să menținem o colecție QnA relevantă și utilă pentru toți."
        },
        "reviewQueue": {
            "heading": "Coadă de verificare",
            "subHeading": "Verificați și aprobați sau respingeți cererile de încărcare a aplicațiilor în așteptare. Verificările dvs. în timp util ne ajută să menținem o colecție de aplicații relevantă și utilă pentru toți."
        },
        "activityLog": {
            "heading": "Jurnal de activități"
        },
        "quickActions": {
            "title": "Acțiuni rapide",
            "onboardNewApp": "Adaugă aplicație nouă",
            "manageApps": "Gestionează aplicații",
            "defaultApps": "Aplicații implicite",
            "onboardNewQnA": "Adaugă întrebare și răspuns nou",
            "manageQnA": "Gestionează întrebări și răspunsuri",
            "reviewerDashboard": "Tablou de bord reviewer",
            "reviewApps": "Revizuiește aplicațiile onboardate",
            "reviewQnA": "Revizuiește Q&A onboardate"
        }
    },
    "sourceSelector": {
        "title": "Selectati sursa",
        "allSources": "Toate sursele",
        "allSourcesDesc": "Cautati in toate sursele interne de informatii E.ON",
        "eonKnowledgeBase": "Baza de cunostinte E.ON",
        "eonKnowledgeBaseDesc": "Accesati cunostintele generale ale companiei",
        "eonMyItOrder": "E.ON Comenzile mele IT",
        "eonMyItOrderDesc": "Gestionati si urmariti comenzile de servicii IT",
        "eonItKnowledgeBase": "Baza de cunostinte IT E.ON",
        "eonItKnowledgeBaseDesc": "Gasiti informatii si solutii legate de IT",
        "myGenius": "My Genius",
        "myGeniusDesc": "Explorati cursuri si materiale de invatare interne",
        "confluenceAll": "Confluence (Toate)",
        "confluenceAllDesc": "Cautati documentatia colaborativa",
        "sharepointAll": "Sharepoint (Toate)",
        "sharepointAllDesc": "Rasfoi fisierele si resursele partajate",
        "eonApps": "Aplicatii E.ON",
        "eonAppsDesc": "Descopera si acceseaza aplicatiile companiei",
        "hrPolicies": "Politici HR",
        "hrPoliciesDesc": "Accesati politicile si ghidurile HR",
        "compass": "Compass",
        "compassDesc": "Explorați Intranetul E.ON",
        "back": "Inapoi",
        "search": "Cautati...",
        "noMatches": "Nicio potrivire"
    },
    "ailoader": {
        "thinking": "Gândire",
        "reading": "Citirea surselor",
        "processing": "Procesare",
        "analysing": "Analiza rezultatelor",
        "preparing": "Pregătirea răspunsului",
        "working": "Lucrez la răspunsul tău - Poate dura puțin."
    },
    "compassScopeSelector": {
        "title": "Selectați unitatea de afaceri",
        "iconLabel": "Domeniu de căutare",
        "localSearch": "Căutare locală",
        "compassWideSearch": "Căutare Compass-wide",
        "resetToCompassWide": "Resetați la căutare Compass-wide",
        "switchToLocal": "Comutați la căutare locală",
        "localDescription": "Căutați în compania dvs. și postările publice",
        "compassWideDescription": "Căutați în toate unitățile de afaceri"
    },
    "errorMessages": {
        "azureAiContentViolation": "Răspunsul a fost filtrat deoarece interogarea a declanșat politica de gestionare a conținutului Azure OpenAI. Vă rugăm să modificați interogarea și să încercați din nou."
    }
}
